class ze {
  constructor(t) {
    this.mode = t;
  }
  async test() {
    return this.mode;
  }
}
function te(s) {
  return s.entryType === "resource" && s.hasOwnProperty("encodedBodySize");
}
function ee(s) {
  return s.hasOwnProperty("connection") && s.connection.hasOwnProperty("downlink");
}
class _e {
  constructor(t, e) {
    this.proxy = t, this.callback = e;
  }
  async test() {
    const t = await this.proxy.test();
    return this.callback(t), t;
  }
}
class Ge {
  constructor(t, e) {
    this.threshold = t, this.fallback = e;
  }
  async test() {
    const t = window.navigator;
    return ee(t) ? t.connection.downlink >= this.threshold ? "high" : "low" : this.fallback.test();
  }
}
class We {
  constructor(t, e, r) {
    this.threshold = t, this.entryBandwidthExractor = e, this.fallback = r;
  }
  async test() {
    if (!window.performance || !window.performance.getEntries)
      return this.fallback.test();
    const t = window.performance.getEntries().filter(te);
    let e = 0, r = 0;
    for (let n = 0; n < t.length; n++) {
      const i = this.entryBandwidthExractor(t[n]);
      i !== null && (r++, e += i);
    }
    return r === 0 ? this.fallback.test() : e / r > this.threshold ? "high" : "low";
  }
}
class Xe {
  constructor(t, e, r, n) {
    this.assets = t, this.timeout = e, this.threshold = r, this.fallback = n;
  }
  async test() {
    const t = Date.now() + this.timeout;
    let e = 0, r = 0;
    for (let i = 0; i < this.assets.length; i++) {
      const o = t - Date.now();
      if (o <= 0)
        break;
      const { url: a, size: h } = this.assets[i];
      try {
        const c = await this.testURL(a, o);
        e += c, r += h;
      } catch {
        break;
      }
    }
    return r === 0 ? this.fallback.test() : r / 1048578 / (e / 1e3) < this.threshold ? "low" : "high";
  }
  testURL(t, e) {
    return new Promise((r, n) => {
      const i = new XMLHttpRequest();
      let o;
      i.onreadystatechange = () => {
        i.readyState === XMLHttpRequest.HEADERS_RECEIVED && (o = Date.now());
      }, i.onload = () => {
        if (!o)
          return n("Could not time");
        r(Date.now() - o);
      }, i.onerror = n, setTimeout(() => {
        n("aborted"), i.abort();
      }, e), i.open("GET", t), i.send();
    });
  }
}
class Qe {
  constructor(t, e, r) {
    this.proxy = t, this.storage = e, this.storageKey = r;
  }
  async test() {
    const t = this.storage.get(this.storageKey);
    return t || (this.cachedPromise || (this.cachedPromise = this.proxy.test(), this.storage.set(this.storageKey, await this.cachedPromise)), this.cachedPromise);
  }
}
class Ht {
  /**
   * @param {boolean} strict when a dependency is missing, throw an error
   */
  constructor(t = !0) {
    this.strict = t, this.services = {}, this.serviceLocations = {}, this.loadedBlocks = /* @__PURE__ */ new Set();
  }
  // public get(name: string, overrides?: any): Promise<TypeLookup extends undefined ? any : never>;
  get(t, e = {}) {
    if (e.hasOwnProperty(t))
      return e[t];
    const r = this.services[t];
    if (r) {
      if (r.value !== void 0)
        return Promise.resolve(r.value);
      if (r.value === void 0)
        return r.value = Promise.resolve().then(() => this.evaluate(r.definition, {}));
    }
    const n = this.serviceLocations[t];
    if (n)
      return n.loadPromise === void 0 && (n.loadPromise = n.loadServices().then((o) => this.setFromDefinition(o))), n.loadPromise.then(() => this.get(t));
    const i = `No service defined for ${t}`;
    if (this.strict)
      throw new Error(i);
    return console.warn(i), Promise.resolve(void 0);
  }
  async inject(t, e = {}) {
    return this.evaluate(new G(t), e);
  }
  async injectAndInstantiate(t, e = {}) {
    return this.evaluate(new G(t), e);
  }
  set(t, e) {
    if (t in this.services)
      throw new Error(`service "${t} already defined!`);
    this.services[t] = { definition: new G(e), value: void 0 };
  }
  setInstantiable(t, e) {
    if (t in this.services)
      throw new Error(`service "${t} already defined!`);
    this.services[t] = { definition: new G(e), value: void 0 };
  }
  setFromDefinition(t) {
    this.loadedBlocks.has(t) || (this.loadedBlocks.add(t), t(this));
  }
  setExternal(t, e) {
    const r = {
      services: [],
      loadPromise: void 0,
      loadServices: e
    };
    t.forEach((n) => this.serviceLocations[n] = r);
  }
  async evaluate(t, e) {
    const r = t.getDependencyNames(), n = await Promise.all(r.map((i) => this.get(i, e)));
    return t.evaluate(n);
  }
  getDependencyGraph() {
    const t = {};
    for (const e in this.services) {
      if (!this.services.hasOwnProperty(e))
        continue;
      const n = this.services[e].definition.getDependencyNames(), i = t[e] ?? [];
      t[e] = i, n.forEach((o) => {
        const a = t[o] ?? [];
        t[o] = a, i.push(o);
      });
    }
    return t;
  }
  findCycle() {
    const t = this.getDependencyGraph(), e = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), n = [];
    function i(o) {
      if (!e.has(o)) {
        e.add(o), r.add(o), n.push(o);
        for (const a of t[o])
          if (!e.has(a) && i(a) || r.has(a))
            return !0;
      }
      return r.delete(o), n.pop(), !1;
    }
    for (const o in t)
      if (!e.has(o) && i(o))
        return n;
    return null;
  }
}
function re(s) {
  return s = s.replace(/\/\*(.*?)\*\//sg, ""), s = s.replace(/\/\/(.*)/g, ""), s;
}
function Ot(s) {
  return s = s.replace(/\s+/g, ""), s === "" ? [] : s.split(",");
}
function ne(s) {
  const t = re(s.toString());
  let e = [];
  if (t.indexOf("class ") === 0) {
    const o = t.match(/constructor\s*\(\s*([\s\S]*?)\s*\)/i);
    return o && (e = Ot(o[1])), {
      instantiable: !0,
      target: s,
      argNames: e
    };
  }
  const n = Object.prototype.toString.call(s);
  let i = n === "[object AsyncFunction]";
  if (n === "[object Function]" || i) {
    let o = !1;
    const a = t.match(/^(async\s+)?\s*(function|function\s+[a-zA-Z0-9_$]+)?\s*\((.*?)\)/);
    return a && (o = !a[2], i = i || !!a[1], e = Ot(a[3])), i || o ? {
      instantiable: !1,
      target: s,
      argNames: e
    } : {
      instantiable: !0,
      target: s,
      argNames: e
    };
  }
  throw new Error("Unhandled");
}
class G {
  constructor(t) {
    this.target = t;
  }
  getStat() {
    return this.stat ? this.stat : this.stat = ne(this.target);
  }
  getDependencyNames() {
    return this.getStat().argNames;
  }
  evaluate(t) {
    const e = this.getStat();
    return e.instantiable ? new e.target(...t) : e.target(...t);
  }
}
class qt {
  async load(t) {
    try {
      const { accessPaths: e, moduleId: r } = this.parsePath(t);
      let n = await this.loadModule(r);
      return n = this.traverseTree(n, e), this.resolveModule(n);
    } catch (e) {
      throw e instanceof Error ? new Error(`Failed to load module "${t}": ${e.message}`) : e;
    }
  }
  resolveModule(t) {
    return typeof t == "object" && "default" in t ? t.default : t;
  }
  traverseTree(t, e) {
    let r = t;
    for (let n = 0; n < e.length; n++) {
      const i = e[n];
      if (!(typeof r == "object" && i in r))
        throw new Error(`Cannot access path ${i}"`);
      r = r[i];
    }
    return r;
  }
  parsePath(t) {
    const e = t.split("."), r = e.shift();
    if (!r)
      throw new Error("No path to load");
    return { moduleId: r, accessPaths: e };
  }
}
class mt extends qt {
  constructor() {
    super();
    const t = mt.getRequire();
    if (!t)
      throw new Error("RequireJS not installed");
    this.requirejs = t;
  }
  static getRequire() {
    if ("require" in window && window.require.name === "requirejs")
      return window.require;
  }
  loadModule(t) {
    return new Promise((e) => {
      this.requirejs([t], e);
    });
  }
}
const se = {
  baseUrl: "/",
  paths: {},
  extension: ".js"
};
class Ye extends qt {
  constructor(t = {}) {
    super(), this.config = { ...se, ...t };
  }
  toUrl(t) {
    let e = t + this.config.extension;
    for (const r in this.config.paths) {
      const n = new RegExp("^" + r);
      if (this.config.paths.hasOwnProperty(r) && n.test(e)) {
        e = e.replace(n, this.config.paths[r]);
        break;
      }
    }
    return /^\//.test(e) || (e = this.config.baseUrl + e), this.config.urlArgs && (e += "?" + this.config.urlArgs), e;
  }
  loadModule(t) {
    return import(this.toUrl(t));
  }
}
class ie {
  constructor(t, e = new Ht()) {
    this.moduleLoader = t, this.dependencyInjector = e;
  }
  async bootstrap(t, e) {
    if (typeof t == "string") {
      const r = await this.moduleLoader.load(t);
      return this.dependencyInjector.injectAndInstantiate(r, e);
    }
    return this.dependencyInjector.inject(t, e);
  }
  /**
   * @deprecated use Injector.setFromDefinition
   */
  registerServices(t) {
    this.dependencyInjector.setFromDefinition(t);
  }
}
class Je extends ie {
  constructor(t = new Ht()) {
    super(new mt(), t);
  }
}
const Tt = {
  decode(s) {
    let t, e = null;
    if (!s || typeof s != "string")
      throw new Error("Could not decode XMLDocument");
    try {
      t = new DOMParser(), e = t.parseFromString(s, "text/xml");
    } catch (r) {
      console.error(r);
    }
    if (e && e.documentElement && !e.getElementsByTagName("parsererror").length)
      return e;
    throw new Error("Invalid XML: " + s);
  },
  encode(s) {
    return new XMLSerializer().serializeToString(s);
  }
}, Ze = {
  encode(s) {
    return JSON.stringify(s);
  },
  decode(s) {
    return JSON.parse(s);
  }
};
function st(s) {
  return s == null || s === !1 ? "" : s === !0 ? "1" : encodeURIComponent(s);
}
function Kt(s) {
  let t = !0;
  const e = {}, r = [];
  for (const n in s) {
    if (!s.hasOwnProperty(n))
      continue;
    const i = parseInt(n, 10);
    if (String(i) != n) {
      t = !1;
      break;
    }
    r.push(i);
  }
  if (t) {
    const n = Math.max.apply(Math, r), i = Math.min.apply(Math, r);
    if (i === 0 && n == r.length - 1) {
      const o = [];
      for (let a = i; a <= n; a++)
        o.push(s[a]);
    }
  }
  for (const n in s)
    s.hasOwnProperty(n) && (s[n] instanceof Object && !Array.isArray(s[n]) ? e[n] = Kt(s[n]) : e[n] = s[n]);
  return e;
}
function lt(s, t) {
  const e = [];
  if (!(s instanceof Object))
    return t === void 0 ? st(s) : encodeURIComponent(t) + "=" + st(s);
  for (const r in s) {
    if (!s.hasOwnProperty(r))
      continue;
    let n = "";
    t === void 0 ? n = r : n = t + "[" + r + "]";
    const i = s[r];
    if (Array.isArray(i))
      for (let o = 0; o < i.length; o++)
        e.push(lt(i[o], n + "[" + o + "]"));
    else if (i instanceof Object)
      for (const o in i)
        i.hasOwnProperty(o) && e.push(lt(i[o], n + "[" + o + "]"));
    else
      e.push(encodeURIComponent(n) + "=" + st(i));
  }
  return e.join("&");
}
const $ = {
  decode(s) {
    const t = s.split("&"), e = {};
    for (let r = 0; r < t.length; r++) {
      let n;
      const i = t[r].split("="), o = decodeURIComponent(i[1] ?? ""), h = decodeURIComponent(i[0]).replace(/\]/g, "").split("[");
      let c = e;
      for (n = 0; n < h.length - 1; n++) {
        const u = h[n];
        c.hasOwnProperty(u) || (c[u] = {}), c = c[u];
      }
      c[h[n]] = o;
    }
    return Kt(e);
  },
  encode(s) {
    return lt(s, void 0);
  }
}, dt = {
  linear: (s) => s,
  easeInQuad: (s) => s * s,
  easeOutQuad: (s) => s * (2 - s),
  easeInOutQuad: (s) => s < 0.5 ? 2 * s * s : -1 + (4 - 2 * s) * s,
  easeInCubic: (s) => s * s * s,
  easeOutCubic: (s) => --s * s * s + 1,
  easeInOutCubic: (s) => s < 0.5 ? 4 * s * s * s : (s - 1) * (2 * s - 2) * (2 * s - 2) + 1,
  easeInQuart: (s) => s * s * s * s,
  easeOutQuart: (s) => 1 - --s * s * s * s,
  easeInOutQuart: (s) => s < 0.5 ? 8 * s * s * s * s : 1 - 8 * --s * s * s * s,
  easeInQuint: (s) => s * s * s * s * s,
  easeOutQuint: (s) => 1 + --s * s * s * s * s,
  easeInOutQuint: (s) => s < 0.5 ? 16 * s * s * s * s * s : 1 + 16 * --s * s * s * s * s
};
function oe(s) {
  return typeof s == "string" && dt.hasOwnProperty(s);
}
const K = class K {
  constructor(t, e, r = K.Easing.linear) {
    this.callback = t, this.duration = e, this.progress = 0, this.lastTimestamp = null, this.running = !1, this.maxStepSize = null, this.easing = K.Easing.linear, this.direction = 1, this.setEasing(r);
  }
  isRunning() {
    return this.running;
  }
  setEasing(t) {
    oe(t) ? this.easing = dt[t] : this.easing = t;
  }
  start() {
    this.running = !0, window.requestAnimationFrame(this.step.bind(this));
  }
  setDuration(t) {
    return this.duration = t, this;
  }
  reverse(t = !0) {
    return this.direction = t ? -1 : 1, this;
  }
  stop() {
    this.running && (this.running = !1, this.lastTimestamp = null);
  }
  setMaxStep(t) {
    this.maxStepSize = t;
  }
  seek(t) {
    this.progress = Math.min(1, Math.max(0, t)), this.callback.call(null, {
      progress: this.progress,
      time: this.easing(this.progress),
      elapsed: this.progress * this.duration,
      duration: this.duration
    });
  }
  step(t) {
    if (!this.running)
      return;
    const e = this.lastTimestamp ? t - this.lastTimestamp : 0, r = Math.min(this.maxStepSize || 1 / 0, e / this.duration) * this.direction;
    if (this.lastTimestamp = t, this.seek(this.progress + r), this.direction === -1 && this.progress === 0 || this.direction === 1 && this.progress === 1) {
      this.stop();
      return;
    }
    window.requestAnimationFrame(this.step.bind(this));
  }
};
K.Easing = dt;
let J = K;
class tr {
  constructor(t, e, r, n = J.Easing.linear) {
    this.fromValue = e, this.lastValue = e, this.toValue = e, this.animation = new J((i) => {
      i.progress === 1 ? this.lastValue = this.toValue : this.lastValue = i.time * (this.toValue - this.fromValue) + this.fromValue, t(this.lastValue), i.progress === 1 && this.lastResolver && (this.lastResolver(), this.lastResolver = void 0);
    }, r, n);
  }
  animateTo(t) {
    return this.lastResolver && this.lastResolver(), this.animation.stop(), this.lastValue === t ? Promise.resolve() : (this.fromValue = this.lastValue, this.toValue = t, this.animation.seek(0), new Promise((e) => {
      this.lastResolver = e, this.animation.start();
    }));
  }
}
class A {
  constructor(t, e, r, n, i, o) {
    if (this.protocol = t, this.hostname = e, this.port = r, this.pathname = n, this.search = i, this.hash = o, n.length && n.charAt(0) != "/")
      throw new Error("Expected path character");
    if (i.length && i.charAt(0) != "?")
      throw new Error("Expected query character");
    if (o.length && o.charAt(0) != "#")
      throw new Error("Expected hash character");
  }
  get path() {
    return this.pathname + this.search + this.hash;
  }
  get href() {
    return this.origin + this.path;
  }
  get origin() {
    return !this.hostname || !this.protocol ? "" : this.protocol + "//" + this.hostname + (this.port ? ":" + this.port : "");
  }
  isCrossOrigin(t = document.location) {
    return this.protocol != t.protocol || this.hostname != t.hostname || this.port != t.port;
  }
  static fromLocation({ protocol: t, hostname: e, port: r, pathname: n, search: i, hash: o } = document.location) {
    return new A(t, e, r, n, i, o);
  }
  static fromURL(t) {
    const e = t.match(/^(https?:)\/\/(([^:/?#]*)(:([0-9]+))?)([/]?[^?#]*)(\?[^#]*|)?(#.*|)?$/);
    return e ? new A(
      e[1] || "",
      e[3] || "",
      e[4] || "",
      e[6] || "",
      e[7] || "",
      e[8] || ""
    ) : null;
  }
  static fromPath(t) {
    const e = t.match(/^([/]?[^?#]*)(\?[^#]*|)(#.*|)$/);
    return e ? e && new A(
      "",
      "",
      "",
      e[1] || "",
      e[2] || "",
      e[3] || ""
    ) : null;
  }
}
function ae(s) {
  return s === !0 ? "1" : s === !1 || s === null ? "" : String(s);
}
function zt(s, t, e = "") {
  if (t !== void 0) {
    if (!(t instanceof Object)) {
      const r = s.ownerDocument.createElement("input");
      r.name = e, r.value = ae(t), s.appendChild(r);
      return;
    }
    for (const r in t)
      t.hasOwnProperty(r) && zt(s, t[r], e ? e + "[" + r + "]" : r);
  }
}
class _t {
  constructor(t = window) {
    this.windowObject = t;
  }
  reload() {
    this.windowObject.location.reload();
  }
  get url() {
    return A.fromLocation(this.windowObject.location);
  }
  set url(t) {
    this.open(t);
  }
  open(t, e = {}) {
    t instanceof A && (t = t.href), e === void 0 && (e = {});
    const r = typeof e.target < "u" ? e.target : "_self", n = typeof e.method < "u" ? e.method : "GET", i = typeof e.data < "u" ? e.data : !1;
    let o = this.windowObject, a = !0;
    if (n == "GET" && i === !1 ? (o = window.open(t, r), a = !1) : r != "_self" && (o = window.open("", r)), !o)
      throw new Error("Could not open target window");
    if (a) {
      const h = o.document.createElement("form");
      h.action = t, h.method = n, o.document.body.appendChild(h), i && zt(h, i), h.submit(), o.document.body.removeChild(h);
    }
    return o != this.windowObject ? new _t(o) : this;
  }
}
function ce(s, t) {
  t.type && console.warn('Event is using reserved "type" property'), t.timestamp && console.warn('Event is using reserved "timestamp" property'), t.type = s, t.timestamp = Date.now();
}
class T {
  /**
   * Defines an EventEmitter
   */
  static create(t) {
    const e = [], r = function(i, o) {
      const a = e.length;
      return e.push(i), o && o.addEventListener("abort", () => e[a] = null), this;
    };
    return r.unsubscribe = (n) => {
      for (let i = 0; i < e.length; i++)
        e[i] === n && (e[i] = null);
    }, r.trigger = (n) => {
      ce(t, n);
      for (let i = 0; i < e.length; i++) {
        const o = e[i];
        if (o)
          try {
            o(n);
          } catch (a) {
            console.error(a);
          }
      }
    }, r.clear = () => {
      for (let n = 0; n < e.length; n++)
        e[n] = null;
    }, r;
  }
}
function k(s, t, e) {
  return e && e.hasOwnProperty(s) && e[s] ? e[s] : t;
}
class Z {
  constructor() {
    this.stringToDate = (e, r = {}) => {
      const n = Z.parseTimestamp(e, k("throwOnFailure", !0, r));
      return n === null ? null : new Date(n);
    }, this.stringToTimestamp = (e, r = {}) => {
      const n = Z.parseTimestamp(e, k("throwOnFailure", !0, r));
      return n === null ? null : k("milliseconds", !0, r) ? n : Math.floor(n / 1e3);
    }, this.timestampToDate = (e, r = {}) => new Date(e * (k("milliseconds", !0, r) ? 1e3 : 1)), this.number = (e, r = {}) => {
      const n = k("decimalPlaces", 0, r), i = k("withCommas", !0, r);
      let o = (~~e).toString();
      if (i && (o = this.int(e).toString()), !n)
        return o;
      const a = Math.pow(10, n), h = (Math.floor(Math.abs(e) * a) % a).toString() + Array(n + 2).join("0");
      return o === "0" && e < 0 && (o = "-0"), o + "." + h.slice(0, n);
    }, this.percent = (e, r = {}) => this.number(e * 100, r) + "%", this.int = (e) => {
      let r = (~~e).toString();
      for (; /(\d+)(\d{3})/.test(r); )
        r = r.replace(/(\d+)(\d{3})/, "$1,$2");
      return r;
    }, this.float = (e, r = { decimalPlaces: 1 }) => this.number(e, r), this.largeFloat = (e, r = {}) => {
      const n = k("significantDigits", 3, r), i = Math.abs(e);
      if (i >= 1e15)
        return e.toPrecision(3);
      const o = i < 10 ? 1 : Math.floor(Math.log(i) * Math.LOG10E), a = Math.floor(o / 3), h = a * 3 + (n - o);
      return (e / Math.pow(1e3, a)).toFixed(h - 1) + (["", "k", "m", "b", "t"][a] || "");
    }, this.largeInt = (e, r = {}) => Math.abs(e) < 1e3 ? e.toFixed(0) : this.largeFloat(e, r), this.lexile = (e, r = {}) => (k("rounded", !1, r) && (e = Math.round(e / 5) * 5), (e <= 0 ? "BR " : "") + this.number(Math.abs(e), { decimalPlaces: 0, withCommas: !1 }) + "L"), this.lexileDiff = (e) => (e <= 0 ? "-" : "+") + this.number(Math.abs(e), { decimalPlaces: 1, withCommas: !1 }) + "L", this.timezone = (e) => {
      const r = e.toString().match(/\(([a-z\s]+)\)/i);
      return r ? r[1] : null;
    }, this.date = (e) => {
      const r = e.toString().split(" ");
      return [1, 2, 3].map(function(n) {
        return r[n];
      }).join(" ");
    }, this.dateLocale = (e) => {
      var r;
      return e.toLocaleDateString ? e.toLocaleDateString(((r = document == null ? void 0 : document.documentElement) == null ? void 0 : r.lang) || "", {
        month: "numeric",
        day: "numeric",
        year: "numeric"
      }) : this.date(e);
    }, this.dateUTC = (e) => {
      const r = e.toUTCString().split(" ");
      return [2, 1, 3].map(function(n) {
        return r[n];
      }).join(" ");
    };
    const t = (/* @__PURE__ */ new Date()).getTimezoneOffset() * 6e4;
    this.dateUTCLocale = (e, r = {}) => {
      let n = t;
      return r && r.hasOwnProperty("timezoneOffset") && (n = r.timezoneOffset * 1e3), this.dateLocale(new Date(Number(e) + n));
    }, this.dateShortUTC = (e) => [
      e.getUTCMonth() + 1,
      e.getUTCDate(),
      e.getUTCFullYear().toString().slice(2)
    ].join("/"), this.dateShort = (e) => [
      e.getMonth() + 1,
      e.getDate(),
      e.getFullYear().toString()
    ].join("/"), this.dateTime = (e) => this.date(e) + " " + this.time(e), this.dateTimeShort = (e) => this.dateShort(e) + " " + this.time(e), this.time = (e) => (e.getHours() % 12 || 12) + ":" + e.getMinutes().toString(10).padStart(2, "0") + ":" + e.getSeconds().toString(10).padStart(2, "0") + (e.getHours() >= 12 ? " PM" : " AM"), this.dateYMD = (e) => [
      e.getUTCFullYear(),
      (1 + e.getUTCMonth()).toString(10).padStart(2, "0"),
      e.getUTCDate().toString(10).padStart(2, "0")
    ].join("-"), this.hhmmss = (e) => Math.floor(e / 3600) + ":" + Math.floor(e % 3600 / 60).toString(10).padStart(2, "0") + ":" + Math.floor(e % 60).toString(10).padStart(2, "0"), this.implode = (e, r = "and") => e.length < 3 ? e.join(" " + r + " ") : e.slice(0, -1).join(", ") + ", " + r + " " + e[e.length - 1], this.printf = (e, r) => {
      const n = /%((\d+)\$)?([-+ 0]*('.)?[-+ 0]*)?(\d+)?(.(\d+))?([sducoxXbeEfFgGhH%])/g;
      let i = 0;
      return e.replace(n, (o, a, h, c, u, l, d, f, y) => {
        if (y === "%")
          return "%";
        const m = h ? Number(h) - 1 : i++;
        c = c ?? "";
        const p = l ? Number(l) : 0, v = f ? Number(f) : 0, w = c.includes("-"), x = c.includes("+"), L = c.includes("0");
        let _ = u ? u[1] : c.includes(" ") ? " " : "";
        const rt = w ? "padEnd" : "padStart";
        if (y === "s") {
          let I = String(r[m]);
          return v && (I = I.slice(0, v)), _ || (_ = L ? "0" : " "), I[rt](p, _);
        }
        if (y === "d" || y === "f") {
          const I = Number(r[m]), Zt = y === "f" && v ? v : 0, nt = I < 0 ? "-" : x ? "+" : "", xt = Math.abs(I).toFixed(Zt);
          return L ? nt + xt[rt](p - nt.length, "0") : (nt + xt)[rt](p, _ || " ");
        }
        throw new Error("specifier " + y + " not supported");
      });
    }, this.json = (e, r) => {
      const n = k("pretty", !0, r);
      return JSON.stringify(e, void 0, n ? "	" : void 0);
    };
  }
  options(t, e) {
    return (r, n = {}) => t(r, { ...n, ...e });
  }
  nullable(t, e = "—") {
    return this.default(t, e);
  }
  /**
   * Returns a formatter that handles null or undefined values with a specific replacement value.
   */
  default(t, e) {
    return (r, n = {}) => r == null ? e : t(r, n);
  }
  static parseTimestamp(t, e) {
    const r = t.indexOf(" ") < 0 ? t + "T00:00:00Z" : t.replace(" ", "T") + "Z", n = Date.parse(r);
    if (!isNaN(n))
      return n;
    if (e)
      throw new Error(`Could not parse date string ${t}`);
    return console.warn(`Could not parse date string ${t}`), null;
  }
}
class er {
  constructor(t) {
    this.document = t;
  }
  getValue(t) {
    const e = new RegExp("(^|; )" + t + "=([^;]*)?(;|$)"), r = this.document.cookie.match(e);
    return r ? r[2] : null;
  }
  listKeys() {
    return this.document.cookie.split("; ").map((t) => t.split("=")[0]);
  }
  setValue(t, e, r = "/", n = null) {
    let i = t + "=" + e + ";path=" + r + ";";
    n && (i += "expires=" + n.toUTCString()), this.document.cookie = i;
  }
}
function Gt(s, t) {
  Error.call(this, ""), this.message = t, this.token = s;
}
Gt.prototype = Object.create(Error.prototype);
class W {
  constructor(t, e, r) {
    this.header = t, this.payload = e, this.signature = r;
  }
  static parseSection(t) {
    return JSON.parse(window.atob(t.replace(/-/g, "+").replace(/_/g, "/")));
  }
  static parse(t) {
    const e = t.split(".");
    if (e.length !== 3)
      throw new Gt(t, "Invalid JWT token");
    return new W(
      W.parseSection(e[0]),
      W.parseSection(e[1]),
      e[2]
    );
  }
  secondsToLive(t = /* @__PURE__ */ new Date()) {
    return Math.floor(this.payload.exp - t.getTime() / 1e3);
  }
  isExpired(t = /* @__PURE__ */ new Date()) {
    return this.secondsToLive(t) < 0;
  }
}
const P = class P {
  constructor() {
    this.encoderDecoders = [], this.onResponse = T.create("response"), this.onRedirect = T.create("timeout");
  }
  static makeStandard() {
    const t = new P();
    return t.addEncoderDecoder({
      test: (e) => e === P.ENC_JSON,
      encode: JSON.stringify,
      decode: (e) => e.json()
    }), t.addEncoderDecoder({
      test: (e) => e === P.ENC_FORM_DATA,
      encode: $.encode
    }), t.addEncoderDecoder({
      test: (e) => e === "application/xml",
      encode: Tt.encode,
      decode: (e) => e.text().then((r) => Tt.decode(r))
    }), t;
  }
  addEncoderDecoder(t) {
    this.encoderDecoders.push(t);
  }
  makeUniqueName() {
    let t;
    for (; t === void 0 || window.hasOwnProperty(t); ) {
      const e = Math.floor(Math.random() * 1e13).toString(16);
      t = "myon_" + btoa(e).replace(/=/g, "");
    }
    return t;
  }
  jsonp(t, e = {}) {
    return new Promise((r, n) => {
      const i = document.createElement("script");
      function o() {
        i.parentNode && i.parentNode.removeChild(i);
      }
      e.abortController && e.abortController.signal.addEventListener("abort", () => {
        o(), n("aborted");
      });
      const a = encodeURIComponent(this.makeUniqueName()), h = encodeURIComponent(e.jsonp ?? "callback");
      let c = t + (t.indexOf("?") === -1 ? "?" : "&") + h + "=" + a;
      e.query && (c += "&" + $.encode(e.query)), i.setAttribute("src", c), i.setAttribute("crossorigin", e.crossorigin ?? "anonymous"), i.setAttribute("type", "application/javascript"), window[a] = (u) => {
        o(), r(u);
      }, document.body.appendChild(i);
    });
  }
  async encode(t, e) {
    for (const r of this.encoderDecoders)
      if (r.encode && r.test(e))
        return r.encode(t);
    return "";
  }
  decode(t, e) {
    for (const r of this.encoderDecoders)
      if (r.decode && r.test(e))
        return r.decode(t);
    return t.text();
  }
  getDataTypeFromHeader(t) {
    return t ? (t == null ? void 0 : t.split(";")[0]) ?? "" : "";
  }
  async ajax(t, e = {}) {
    const r = e.method || "GET", n = e.encoding || P.ENC_FORM_DATA, i = e.query ? $.encode(e.query) : "", o = {};
    let a;
    r !== "GET" && e.body && (a = await this.encode(e.body, n)), i && (t += (t.indexOf("?") >= 0 ? "&" : "?") + i), n && (o["Content-Type"] = n);
    const h = e.abortController ?? new AbortController(), c = await fetch(t, {
      method: r,
      headers: o,
      body: a,
      signal: h.signal,
      credentials: e.credentials
    });
    this.onResponse.trigger({ sender: this, response: c }), c.redirected && this.onRedirect.trigger({ sender: this, url: c.url, response: c });
    const u = e.decoding ?? this.getDataTypeFromHeader(c.headers.get("Content-Type")) ?? "";
    return this.decode(c, u);
  }
  get(t, e = {}) {
    return e.method = "GET", this.ajax(t, e);
  }
  post(t, e = {}) {
    return e.method = "POST", this.ajax(t, e);
  }
  put(t, e = {}) {
    return e.method = "PUT", this.ajax(t, e);
  }
  patch(t, e = {}) {
    return e.method = "PATCH", this.ajax(t, e);
  }
  delete(t, e = {}) {
    return e.method = "DELETE", this.ajax(t, e);
  }
};
P.ENC_FORM_DATA = "application/x-www-form-urlencoded", P.ENC_JSON = "application/json";
let kt = P;
class he extends Error {
  constructor(t) {
    super(t);
    const e = new.target.prototype;
    this.__proto__ = e;
  }
}
const it = "_extension", X = "index", ue = "index", le = "html";
class St extends he {
}
class tt {
  constructor(t, e = X, r = {}, n = le) {
    this.path = t, this.action = e, this.parameters = r, this.extension = n;
  }
  withParameters(t, e = !1) {
    return e || (t = { ...this.parameters, ...t }), new tt(this.path, this.action, t, this.extension);
  }
}
const bt = class bt {
  generate(t, e = null, r = {}, n) {
    e === null && (e = X);
    const i = document.location.port ? ":" + document.location.port : "", o = document.location.protocol + "//", a = document.location.hostname;
    return o + a + i + this.generatePath(t, e, r, n);
  }
  generatePath(t, e = null, r = {}, n) {
    return e === null && (e = X), n === void 0 && r.hasOwnProperty(it) && (n = r[it], delete r[it]), this.routeInfoToPath(new tt(t, e, r, n));
  }
  routeInfoToPath(t) {
    const e = $.encode(t.parameters);
    return "/" + t.path.replace(/\\/g, "/") + (t.extension ? "." + t.extension : "") + (t.action != X ? ":" + t.action : "") + (e ? "?" + e : "");
  }
  routeFromPathInfo(t) {
    if (t.origin && t.isCrossOrigin())
      throw new St("Cannot create route from cross origin domain");
    const e = t.pathname.match(/\/([^.:]+)?(\.([a-z]+))?(:(.*))?$/), r = t.search ? $.decode(t.search.slice(1)) : {};
    if (!e)
      throw new Error("Does not conform to myon route");
    let n = (e[1] || "").replace(/\//g, "\\");
    return (n[n.length - 1] == "\\" || !n.length) && (n += ue), new tt(
      n,
      e[5],
      r,
      e[3]
    );
  }
  parse(t) {
    const e = A.fromURL(t) || A.fromPath(t);
    if (e)
      return this.routeFromPathInfo(e);
  }
};
bt.CrossOriginPathError = St;
let Ct = bt;
const ot = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  NUM_0: 48,
  NUM_1: 49,
  NUM_2: 50,
  NUM_3: 51,
  NUM_4: 52,
  NUM_5: 53,
  NUM_6: 54,
  NUM_7: 55,
  NUM_8: 56,
  NUM_9: 57,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90,
  NUMPAD_0: 96,
  NUMPAD_1: 97,
  NUMPAD_2: 98,
  NUMPAD_3: 99,
  NUMPAD_4: 100,
  NUMPAD_5: 101,
  NUMPAD_6: 102,
  NUMPAD_7: 103,
  NUMPAD_8: 104,
  NUMPAD_9: 105
}, U = {
  8: "Backspace",
  9: "Tab",
  13: "Enter",
  16: "Shift",
  17: "Ctrl",
  18: "Alt",
  27: "Esc",
  32: "Space",
  33: "Page Up",
  34: "Page Down",
  35: "End",
  36: "Home",
  37: "←",
  38: "↑",
  39: "→",
  40: "↓",
  48: "0",
  49: "1",
  50: "2",
  51: "3",
  52: "4",
  53: "5",
  54: "6",
  55: "7",
  56: "8",
  57: "9",
  65: "A",
  66: "B",
  67: "C",
  68: "D",
  69: "E",
  70: "F",
  71: "G",
  72: "H",
  73: "I",
  74: "J",
  75: "K",
  76: "L",
  77: "M",
  78: "N",
  79: "O",
  80: "P",
  81: "Q",
  82: "R",
  83: "S",
  84: "T",
  85: "U",
  86: "V",
  87: "W",
  88: "X",
  89: "Y",
  90: "Z",
  96: "Numpad 0",
  97: "Numpad 1",
  98: "Numpad 2",
  99: "Numpad 3",
  100: "Numpad 4",
  101: "Numpad 5",
  102: "Numpad 6",
  103: "Numpad 7",
  104: "Numpad 8",
  105: "Numpad 9"
};
function rr(s) {
  return U[s] ?? "";
}
class de {
  constructor(t, e, r = {}) {
    this.name = t, this.keyCode = e, this.onAvailabilityChange = T.create("availabilityChange"), this.onInvoke = T.create("invoke"), this.target = typeof r.target > "u" ? document.documentElement : r.target, this.shiftKey = typeof r.shiftKey > "u" ? !1 : r.shiftKey, this.altKey = typeof r.altKey > "u" ? !1 : r.altKey, this.ctrlKey = typeof r.ctrlKey > "u" ? !1 : r.ctrlKey, this.disabledValue = typeof r.disabled > "u" ? !1 : r.disabled, this.sequenceId = [Number(this.shiftKey), Number(this.altKey), Number(this.ctrlKey), this.keyCode].join("-"), this.label = this.buildLabel();
  }
  get disabled() {
    return this.disabledValue;
  }
  set disabled(t) {
    t != this.disabledValue && (this.disabledValue = t, this.onAvailabilityChange.trigger({ command: this }));
  }
  invoke() {
    this.onInvoke.trigger({ command: this });
  }
  buildLabel() {
    let t = U[this.keyCode] ?? "";
    return this.shiftKey && (t = U[ot.SHIFT] + " + " + t), this.altKey && (t = U[ot.ALT] + " + " + t), this.ctrlKey && (t = U[ot.CTRL] + " + " + t), t;
  }
}
const Et = class Et {
  constructor(t = document) {
    this.targetDocument = t, this.elements = [], this.elementCommands = [], this.activeElement = null, this.disabled = !1, this.onAvailabilityChange = T.create("availabilityChange"), this.onCommandInvoke = T.create("commandInvoke"), this.targetDocument.addEventListener("keydown", (e) => {
      if (this.disabled)
        return;
      const r = this.getAvailableCommandsFromElement(e.target);
      for (let n = 0; n < r.length; n++) {
        const { keyCommand: i, overridden: o } = r[n];
        if (!i.disabled && !o && i.keyCode === e.keyCode && i.altKey === e.altKey && i.shiftKey === e.shiftKey) {
          i.invoke(), e.preventDefault(), e.stopPropagation();
          return;
        }
      }
    }), this.targetDocument.addEventListener("keyup", () => {
      this.disabled || document.activeElement !== this.activeElement && (this.activeElement = document.activeElement, this.onAvailabilityChange.trigger({
        commands: this.getAvailableCommandsFromElement(this.activeElement)
      }));
    });
  }
  register(...t) {
    for (let e = 0; e < t.length; e++) {
      const r = t[e], n = this.getElementIndex(r.target);
      r.onAvailabilityChange(() => {
        this.onAvailabilityChange.trigger({
          commands: this.getAvailableCommandsFromElement(this.activeElement)
        });
      }), r.onInvoke(() => {
        this.onCommandInvoke.trigger({ command: r });
      }), this.elementCommands[n].push(r);
    }
    this.onAvailabilityChange.trigger({
      commands: this.getAvailableCommandsFromElement(this.activeElement)
    });
  }
  getAvailableCommandsFromFocus() {
    return this.getAvailableCommandsFromElement(document.activeElement || document.documentElement);
  }
  targetIgnoresCommands(t) {
    const e = String(t.tagName).toLowerCase();
    if (e === "textarea")
      return !0;
    if (e !== "input")
      return !1;
    const r = String(t.getAttribute("type")).toLowerCase();
    return !(r === "checkbox" || r === "radio" || r === "button" || r === "submit");
  }
  getAvailableCommandsFromElement(t) {
    if (t === null)
      return [];
    if (t instanceof Element && this.targetIgnoresCommands(t))
      return [];
    let e = t;
    const r = [], n = {};
    for (; e.parentNode; ) {
      const i = this.elements.indexOf(e);
      if (e = e.parentNode, i !== -1)
        for (let o = 0; o < this.elementCommands[i].length; o++) {
          const a = this.elementCommands[i][o];
          r.push({
            overridden: n.hasOwnProperty(a.sequenceId),
            keyCommand: a
          }), a.disabled || (n[a.sequenceId] = !0);
        }
    }
    return r;
  }
  getElementIndex(t) {
    const e = this.elements.indexOf(t);
    return e !== -1 ? e : (this.elements.push(t), this.elementCommands.push([]), this.elements.length - 1);
  }
};
Et.Command = de;
let Pt = Et;
class nr {
  constructor() {
    this.onChange = T.create("change"), this.hidden = "hidden", this.bind(), this.focusState !== "unknown" && this.onChange.trigger({ focusState: this.focusState });
  }
  getFocusStateFromEvent(t, e) {
    return t = t || window.event, t.type === "focus" || t.type === "focusin" || t.type === "pageshow" ? "focus" : t.type === "blur" || t.type === "focusout" || t.type === "pagehide" ? "blur" : this.getFocusStateFromElement(e);
  }
  getFocusStateFromElement(t) {
    return t[this.hidden] === void 0 ? "unknown" : t[this.hidden] ? "blur" : "focus";
  }
  get focusState() {
    return this.getFocusStateFromElement(document);
  }
  bind() {
    const t = this, e = function(r) {
      t.onChange.trigger({ focusState: t.getFocusStateFromEvent(r, this) });
    };
    if ("hidden" in document) {
      this.hidden = "hidden", document.addEventListener("visibilitychange", e);
      return;
    }
    if ("mozHidden" in document) {
      this.hidden = "mozHidden", document.addEventListener("mozvisibilitychange", e);
      return;
    }
    if ("webkitHidden" in document) {
      this.hidden = "webkitHidden", document.addEventListener("webkitvisibilitychange", e);
      return;
    }
    if ("msHidden" in document) {
      this.hidden = "msHidden", document.addEventListener("msvisibilitychange", e);
      return;
    }
    if ("onfocusin" in document) {
      this.chainToEvent(document, ["onfocusin", "onfocusout"], e);
      return;
    }
    this.chainToEvent(window, ["onpageshow", "onpagehide", "onfocus", "onblur"], e);
  }
  chainToEvent(t, e, r) {
    for (let n = 0; n < e.length; n++) {
      const i = e[n];
      if (t[i]) {
        const o = t[i];
        t[i] = function(a) {
          try {
            o.call(this, a);
          } catch (h) {
            console.error(h);
          }
          r.call(this, a);
        };
      } else
        t[i] = r;
    }
  }
}
const at = "fc_target", z = class z {
  constructor(t = document) {
    this.doc = t, this.stack = [], this.stack.push({ root: t.body }), t.documentElement.addEventListener("keydown", (e) => {
      const r = this.peek();
      if (e.keyCode == 27 && r && r.onEscape) {
        r.onEscape();
        return;
      }
      e.keyCode == 9 && this.constrainKey(e.shiftKey) && e.preventDefault();
    }), t.documentElement.addEventListener("focus", ({ target: e }) => {
      !(e instanceof Element) || !e.closest(z.FOCUSABLE_QUERY) || this.constrainFocus();
    });
  }
  push(t, e) {
    this.peek().lastElement = this.doc.activeElement, this.stack.push({
      root: t,
      onEscape: e
    }), this.constrainFocus();
  }
  pop(t = !1) {
    if (this.stack.length === 1)
      return !1;
    this.stack.pop();
    const e = this.peek();
    if (!e)
      throw new Error("Nothing left in the stack");
    return e.lastElement && e.lastElement.focus({ preventScroll: t }), !0;
  }
  focusArea(t, e = !1) {
    const r = this.getFocusableElements(t);
    r.length === 0 || document.activeElement instanceof HTMLElement && r.indexOf(document.activeElement) >= 0 || r[0].focus({ preventScroll: e });
  }
  closestFocusable(t) {
    let e = t;
    for (; e && !this.elementIsFocusable(e); )
      e = e.parentNode;
    return e;
  }
  skipArea(t, e = !1) {
    const r = this.getFocusableElements(t), n = this.getFocusableElements(document.body);
    let i = n[0], o = !1;
    for (let a = 0; a < n.length; a++)
      if (r.indexOf(n[a]) !== -1)
        o = !0;
      else if (o) {
        i = n[a];
        break;
      }
    i.focus({ preventScroll: e });
  }
  peek() {
    return this.stack[this.stack.length - 1];
  }
  /*
   * This gets all focusable elements beneath the targeted element.
   * Note that this DOES NOT include the targeted element itself
  	 */
  getFocusableElements(t) {
    this.doc.activeElement && this.doc.activeElement.classList && this.doc.activeElement.classList.add(at);
    const e = t.querySelectorAll(z.FOCUSABLE_QUERY);
    this.doc.activeElement && this.doc.activeElement.classList && this.doc.activeElement.classList.remove(at);
    const r = {}, n = (o) => {
      if (!this.elementIsFocusable(o) && o !== this.doc.activeElement)
        return;
      const a = this.getTabIndex(o);
      r.hasOwnProperty(a) || (r[a] = []), r[a].push(o);
    };
    n(t);
    for (let o = 0; o < e.length; o++)
      n(e[o]);
    const i = Object.keys(r).map(Number);
    return i.sort((o, a) => o > a ? 1 : o === a ? 0 : -1), i.reduce((o, a) => o.concat(r[a]), []);
  }
  getTabIndex(t) {
    return t.hasAttribute("tabindex") ? parseInt(t.getAttribute("tabindex"), 0) : 0;
  }
  elementIsFocusable(t) {
    if (!t.offsetParent || t.hasAttribute("disabled"))
      return !1;
    const e = t.hasAttribute("tabIndex");
    if ((e ? parseInt(t.getAttribute("tabindex"), 0) : 0) === -1)
      return !1;
    if (e || t.hasAttribute("contenteditable"))
      return !0;
    const n = t.tagName.toLowerCase();
    return (n === "a" || n === "area") && t.hasAttribute("href") || (n === "video" || n === "audio") && t.hasAttribute("controls") ? !0 : ["iframe", "object", "embed", "input", "select", "textarea", "button"].indexOf(n) !== -1;
  }
  constrainKey(t) {
    const e = this.getFocusableElements(this.peek().root);
    if (e.length === 0)
      return !0;
    const r = e.indexOf(this.doc.activeElement), n = e.length - 1;
    return t && (r == -1 || r === 0) ? (e[n].focus(), !0) : !t && (r == -1 || r == n) ? (e[0].focus(), !0) : !1;
  }
  constrainFocus() {
    const t = this.getFocusableElements(this.peek().root);
    t.length === 0 || t.indexOf(this.doc.activeElement) >= 0 || t[0].focus();
  }
};
z.FOCUSABLE_QUERY = "a[href], area[href], input:not([disabled]), select:not([disabled]), audio[controls], video[controls], textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable], ." + at;
let Nt = z;
function ct(s, t, e) {
  return Math.min(e, Math.max(t, s));
}
const fe = 0.299, pe = 0.587, me = 0.114;
class O {
  constructor(t, e, r) {
    this.h = t % 360, this.s = Math.min(1, Math.max(0, e)), this.v = Math.min(1, Math.max(0, r));
  }
  toRGB() {
    const t = this.h % 360, e = this.s, r = this.v, n = r * e, i = Math.floor(t / 60), o = n * (1 - Math.abs(t / 60 % 2 - 1));
    let a = 0, h = 0, c = 0;
    switch (i) {
      case 0:
        a = n, h = o;
        break;
      case 1:
        a = o, h = n;
        break;
      case 2:
        h = n, c = o;
        break;
      case 3:
        h = o, c = n;
        break;
      case 4:
        a = o, c = n;
        break;
      default:
        a = n, c = o;
        break;
    }
    const u = r - n;
    return new b((a + u) * 255, (h + u) * 255, (c + u) * 255);
  }
  desaturate(t) {
    return new O(this.h, this.s - t, this.v);
  }
  rotate(t) {
    return new O(this.h + t, this.s, this.v);
  }
  darken(t) {
    return new O(this.h, this.s, this.v - t);
  }
  lighten(t) {
    return new O(this.h, this.s, this.v + t);
  }
  withValue(t) {
    return new O(this.h, this.s, t);
  }
  withSaturation(t) {
    return new O(this.h, t, this.v);
  }
  toString() {
    return Math.round(this.h) + "%, " + Math.round(this.s * 100) + "°, " + Math.round(this.v * 100) + "°";
  }
}
class b {
  constructor(t, e, r, n = 255) {
    this.r = Number(t), this.g = Number(e), this.b = Number(r), this.a = Number(n);
  }
  static strToColor(t) {
    if (t.charAt(0) == "#")
      return b.fromHex(t);
    let e = t.match(/rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/);
    return e ? new b(e[1], e[2], e[3]) : (e = t.match(/rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\)/), e ? new b(e[1], e[2], e[3], e[4]) : null);
  }
  static transparentize(t, e) {
    const r = b.fromHex(t);
    return r instanceof b ? r.transparentize(e) : r;
  }
  static randomHex() {
    return "#" + ("00000" + Math.floor(Math.random() * Math.pow(16, 6)).toString(16)).slice(-6);
  }
  static random() {
    return b.fromHex(b.randomHex());
  }
  static randomHue(t, e) {
    return new O(Math.random() * 360, t, e).toRGB();
  }
  static Black() {
    return new b(0, 0, 0);
  }
  static fromHex(t) {
    let e, r, n, i;
    if (t.charAt(0) != "#")
      return !1;
    if (t.length > 4) {
      if (e = t.substring(1).match(/([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/), !e)
        throw new Error(`Could not parse color string: ${t}`);
      return r = parseInt(e[1], 16), n = parseInt(e[2], 16), i = parseInt(e[3], 16), new b(r, n, i);
    }
    if (e = t.substring(1).match(/([a-fA-F0-9]{1})([a-fA-F0-9]{1})([a-fA-F0-9]{1})/), !e)
      throw new Error(`Could not parse color string: ${t}`);
    return r = parseInt(e[1] + e[1], 16), n = parseInt(e[2] + e[2], 16), i = parseInt(e[3] + e[3], 16), new b(r, n, i);
  }
  getLuminance() {
    return Math.sqrt(
      fe * Math.pow(this.r, 2) + pe * Math.pow(this.g, 2) + me * Math.pow(this.b, 2)
    );
  }
  luminance(t, e = 1) {
    const r = this.toHSV(), n = (u, l) => {
      const d = (l - u) / 2 + u, f = r.withValue(d).toRGB().getLuminance();
      return Math.abs(f - t) <= e ? d : f < t ? n(d, l) : n(u, d);
    }, i = r.withValue(0).toRGB(), o = i.getLuminance();
    if (Math.abs(t - o) <= e)
      return i;
    if (t < o)
      return r.withSaturation(r.s + 0.1).toRGB().luminance(t, e);
    const a = r.withValue(1).toRGB(), h = a.getLuminance();
    if (Math.abs(t - h) <= e)
      return a;
    if (t > h)
      return r.withSaturation(r.s - 0.1).toRGB().luminance(t, e);
    const c = n(0, 1);
    return r.withValue(c).toRGB();
  }
  transparentize(t) {
    return `rgba(${this.r}, ${this.g}, ${this.b}, ${t})`;
  }
  mix(t, e = 0.5) {
    const r = 1 - e;
    return new b(
      this.r * r + t.r * e,
      this.g * r + t.g * e,
      this.b * r + t.b * e
    );
  }
  divide(t) {
    return new b(this.r / t, this.g / t, this.b / t);
  }
  add(t) {
    return new b(this.r + t.r, this.g + t.g, this.b + t.b);
  }
  toHSV() {
    const t = this.r / 255, e = this.g / 255, r = this.b / 255, n = Math.min(t, e, r), i = Math.max(t, e, r), o = i;
    if (n == i)
      return new O(0, 0, o);
    const a = t == n ? e - r : r == n ? t - e : r - t, c = 60 * ((t == n ? 3 : r == n ? 1 : 5) - a / (i - n)), u = (i - n) / i;
    return new O(c, u, o);
  }
  toHex() {
    let t = "#";
    return t += ("0" + Math.round(ct(this.r, 0, 255)).toString(16)).slice(-2), t += ("0" + Math.round(ct(this.g, 0, 255)).toString(16)).slice(-2), t += ("0" + Math.round(ct(this.b, 0, 255)).toString(16)).slice(-2), t;
  }
  toString() {
    return this.toHex();
  }
}
function Wt(s) {
  return s instanceof HTMLElement;
}
function sr(s) {
  if (!Wt(s))
    throw new Error("Element does not match expected type HTMLElement");
  return s;
}
function ge(s, t) {
  return Wt(s) ? s.tagName.toLowerCase() === t : !1;
}
function ir(s, t) {
  if (!ge(s, t))
    throw new Error(`Element does not match expected type ${t}`);
  return s;
}
function or(s) {
  const t = {
    left: 0,
    top: 0
  };
  for (; s; )
    t.left += s.offsetLeft + s.clientLeft, t.top += s.offsetTop + s.clientTop, s = s.offsetParent;
  return t;
}
let ht;
async function ye() {
  ht || (ht = new Promise((s) => {
    let t = !1, e = 1;
    function r(i) {
      (i === !0 ? --e : t) || (t = !0, !(i !== !0 && --e > 0) && s(this));
    }
    function n() {
      document.removeEventListener("DOMContentLoaded", n), window.removeEventListener("load", n), r(!1);
    }
    document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll ? window.setTimeout(r) : (document.addEventListener("DOMContentLoaded", n), window.addEventListener("load", n));
  })), await ht;
}
function ar(s) {
  ye().then(s);
}
function cr(s, t = {}) {
  const e = ((t == null ? void 0 : t.document) ?? document).createElement(s);
  if (Object.entries(t.attrs ?? {}).forEach(([r, n]) => {
    e.setAttribute(r, n);
  }), t.props) {
    for (const r in t.props)
      if (t.props.hasOwnProperty(r)) {
        const n = t.props[r];
        n != null && (e[r] = n);
      }
  }
  return t.children && e.append(...t.children), e;
}
const D = "@@ordinal";
class hr {
  constructor(t, e, r) {
    this.type = t, this.fields = e, this.indexedFields = r, this.onCreate = T.create("create"), this.onDelete = T.create("delete"), this.onUpdate = T.create("update"), this.indexes = {}, this.data = [];
    for (let n = 0; n < this.indexedFields.length; n++)
      this.indexes[this.indexedFields[n]] = {};
  }
  create(t) {
    this.createMany([t]);
  }
  createMany(t) {
    const e = [];
    for (const r in t) {
      if (!t.hasOwnProperty(r))
        continue;
      const n = t[r];
      this.doRecordCreate(n), e.push(n);
    }
    for (let r = 0; r < e.length; r++)
      this.onCreate.trigger({
        record: e[r],
        data: {
          type: "create",
          record: e[r],
          batchNumber: r,
          batchSize: e.length
        }
      });
  }
  readOne(t, e) {
    const r = e ? this.read(t, e) : this.read(t);
    return r.length > 0 ? r[0] : null;
  }
  readAll(t) {
    const e = [];
    for (let r = 0; r < this.data.length; r++) {
      const n = this.data[r];
      n !== null && e.push(n);
    }
    return t !== void 0 ? this.formatResults(e, t) : e;
  }
  read(t, e) {
    let r = 1, n = [];
    const i = (a, h) => {
      if (!this.indexes.hasOwnProperty(a)) {
        const c = [];
        for (let u = 0; u < this.data.length; u++)
          this.data[u][a] == h && c.push(u);
        return c;
      }
      return this.indexes[a].hasOwnProperty(h) ? [...this.indexes[a][h]] : [];
    };
    for (const a in t) {
      if (!t.hasOwnProperty(a))
        continue;
      let h = [];
      const c = t[a];
      if (Array.isArray(c))
        for (let u = 0; u < c.length; u++)
          h = h.concat(i(a, c[u]));
      else
        h = h.concat(i(a, c));
      r === 1 ? n = h : n = n.filter((u) => h.indexOf(u) >= 0), r++;
    }
    const o = n.map((a) => this.data[a]).filter((a) => a !== null);
    return e !== void 0 ? this.formatResults(o, e) : o;
  }
  replace(t, e) {
    this.replaceRecords(t, this.read(e), Object.keys(e));
  }
  replaceAll(t, e) {
    this.replaceRecords(t, this.readAll(), e);
  }
  update(t, e) {
    const r = this.read(e), n = [];
    for (let i = 0; i < r.length; i++) {
      const o = this.doUpdateRecord(r[i], t);
      o !== null && n.push(o);
    }
    this.bulkDispatchUpdates(n);
  }
  delete(t) {
    const e = this.read(t);
    this.bulkDeleteRecords(e);
  }
  validateRecord(t) {
    let e;
    for (e = 0; e < this.fields.length; e++)
      if (!t.hasOwnProperty(this.fields[e]))
        throw new Error("Invalid record of type `" + this.type + "`: missing field: `" + this.fields[e] + "`");
  }
  formatResults(t, e) {
    return t.map((r) => r[e]);
  }
  replaceRecords(t, e, r) {
    const n = [], i = [], o = [], a = {};
    for (let h = 0; h < t.length; h++) {
      const c = t[h], u = {};
      for (let d = 0; d < r.length; d++)
        u[r[d]] = c[r[d]];
      const l = this.readOne(u);
      if (l) {
        const d = this.doUpdateRecord(l, c);
        a[l[D]] = !0, d && i.push(d);
      } else
        n.push(c);
    }
    this.createMany(n);
    for (let h = 0; h < n.length; h++)
      a[n[h][D]] = !0;
    this.bulkDispatchUpdates(i);
    for (let h = 0; h < e.length; h++)
      a.hasOwnProperty(e[h][D]) || o.push(e[h]);
    this.bulkDeleteRecords(o);
  }
  bulkDeleteRecords(t) {
    let e, r;
    for (e = 0; e < t.length; e++)
      r = t[e], this.deleteOrdinal(r[D]), this.onDelete.trigger({
        record: r,
        data: {
          type: "delete",
          record: r,
          batchNumber: e,
          batchSize: t.length
        }
      });
  }
  bulkDispatchUpdates(t) {
    for (let e = 0; e < t.length; e++)
      this.onUpdate.trigger({
        record: t[e].record,
        data: {
          type: "update",
          record: t[e].record,
          batchNumber: e,
          batchSize: t.length,
          changes: t[e].changes
        }
      });
  }
  doRecordCreate(t) {
    let e;
    for (this.validateRecord(t), t[D] = this.data.length, this.data.push(t), e = 0; e < this.indexedFields.length; e++)
      this.addToIndex(this.indexedFields[e], t);
  }
  doUpdateRecord(t, e) {
    let r = !1;
    const n = {};
    for (const i in e) {
      if (!e.hasOwnProperty(i) || t[i] == e[i])
        continue;
      r = !0;
      const o = this.indexedFields.indexOf(i) !== -1;
      o && this.removeFromIndex(i, t), n[i] = {
        from: t[i],
        to: e[i]
      }, t[i] = e[i], o && this.addToIndex(i, t);
    }
    return r ? { record: t, changes: n } : null;
  }
  deleteOrdinal(t) {
    const e = this.data[t];
    if (!e)
      throw new Error("Could not delete record " + t);
    for (let r = 0; r < this.indexedFields.length; r++)
      this.removeFromIndex(this.indexedFields[r], e);
    this.data[t] = null;
  }
  addToIndex(t, e) {
    const r = e[t];
    this.indexes[t].hasOwnProperty(r) || (this.indexes[t][r] = []), this.indexes[t][r].push(e[D]);
  }
  removeFromIndex(t, e) {
    const r = e[t];
    if (!this.indexes[t].hasOwnProperty(r))
      return;
    const n = this.indexes[t][r].indexOf(e[D]);
    n != -1 && this.indexes[t][r].splice(n, 1);
  }
}
class ur {
  constructor() {
    this.seedValue = Math.random();
  }
  seed(t) {
    this.seedValue = t;
  }
  getNext() {
    return this.seedValue = (this.seedValue * 9301 + 49297) % 233280, this.seedValue / 233280;
  }
  getFloat(t, e) {
    return t === void 0 ? (e = 1, t = 0) : e === void 0 && (e = t, t = 0), t + this.getNext() * (e - t);
  }
  getInt(t, e) {
    return t === void 0 ? (e = 100, t = 1) : e === void 0 && (t = 1, e = t), Math.floor(this.getFloat(t, e + 1));
  }
  pick(t) {
    const e = this.getInt(0, t.length - 1);
    return t[e];
  }
}
class M {
  getMany(t) {
    return t.map((e) => this.get(e));
  }
  setMany(t) {
    Object.entries(t).forEach(([e, r]) => this.set(e, r));
  }
}
class gt extends M {
  constructor(t = {}) {
    super(), this.data = t;
  }
  has(t) {
    return this.data.hasOwnProperty(t);
  }
  set(t, e) {
    this.data[t] = e;
  }
  get(t) {
    return this.data[t];
  }
  keys() {
    return Object.keys(this.data);
  }
  remove(t) {
    delete this.data[t];
  }
}
class we extends M {
  constructor(t, e) {
    super(), this.storage = t, this.encoder = e;
  }
  set(t, e) {
    this.storage.setItem(t, this.encoder.encode(e));
  }
  get(t) {
    if (!this.has(t))
      return;
    const e = this.storage.getItem(t);
    return this.encoder.decode(e);
  }
  has(t) {
    return this.storage.hasOwnProperty(t);
  }
  keys() {
    return Object.keys(this.storage);
  }
  remove(t) {
    this.storage.removeItem(t);
  }
}
function H(s) {
  return s.split("; ").reduce(function(t, e) {
    const r = e.indexOf("=");
    return r >= 0 && (t[e.slice(0, r).trim()] = e.slice(r + 1).trim()), t;
  }, {});
}
class lr extends M {
  constructor(t, e) {
    super(), this.prefixString = t, this.proxy = e;
  }
  prefix(t) {
    return this.prefixString + t;
  }
  has(t) {
    return this.proxy.has(this.prefix(t));
  }
  set(t, e) {
    this.proxy.set(this.prefix(t), e);
  }
  get(t) {
    return this.proxy.get(this.prefix(t));
  }
  remove(t) {
    return this.proxy.remove(this.prefix(t));
  }
  keys() {
    return this.proxy.keys().filter((t) => t.indexOf(this.prefixString) === 0).map((t) => t.slice(this.prefixString.length));
  }
}
class dr extends M {
  constructor(t, e) {
    super(), this.maxSize = t, this.proxy = e;
  }
  get size() {
    return this.keys().length;
  }
  entries() {
    const t = [];
    return this.keys().forEach((e) => {
      const r = this.proxy.get(e);
      r && t.push([e, r]);
    }), t.sort((e, r) => e[1].o - r[1].o), t;
  }
  shift(t) {
    const e = this.entries();
    for (let r = 0; r < e.length; r++)
      r < t ? this.remove(e[r][0]) : this.set(e[r][0], e[r][1].v);
  }
  set(t, e) {
    this.size >= this.maxSize && this.shift(1 + (this.size - this.maxSize)), this.proxy.set(t, { o: this.size, v: e });
  }
  keys() {
    return this.proxy.keys();
  }
  remove(t) {
    this.proxy.remove(t);
  }
  get(t) {
    var e;
    return (e = this.proxy.get(t)) == null ? void 0 : e.v;
  }
  has(t) {
    return this.proxy.has(t);
  }
}
class fr extends M {
  constructor(t, e) {
    super(), this.defaultTimeToLive = t, this.proxy = e, this.proxy.keys().forEach((r) => {
      const n = this.proxy.get(r);
      (n === void 0 || n.x * 1e3 < Date.now()) && this.remove(r);
    });
  }
  setWithExpiration(t, e, r) {
    this.proxy.set(t, { v: e, x: Math.floor((Date.now() + r) / 1e3) });
  }
  has(t) {
    return this.get(t) !== void 0;
  }
  set(t, e) {
    this.setWithExpiration(t, e, this.defaultTimeToLive);
  }
  get(t) {
    const e = this.proxy.get(t);
    if (e !== void 0 && !(e.x * 1e3 < Date.now()))
      return e.v;
  }
  keys() {
    return this.proxy.keys().filter((t) => this.has(t));
  }
  remove(t) {
    this.proxy.remove(t);
  }
}
class pr extends M {
  constructor(t, e, r, n) {
    super(), this.defaultTimeToLive = t, this.path = e, this.encoder = r, this.document = n;
  }
  has(t) {
    return H(this.document.cookie).hasOwnProperty(t);
  }
  get(t) {
    const e = H(this.document.cookie);
    if (!e.hasOwnProperty(t))
      return;
    const r = decodeURIComponent(e[t]);
    return this.encoder.decode(r);
  }
  keys() {
    return Object.keys(H(this.document.cookie));
  }
  remove(t) {
    const e = /* @__PURE__ */ new Date(0);
    this.document.cookie = `${t}=; path=${this.path}; expires=${e.toUTCString()}`;
  }
  setWithExpiration(t, e, r) {
    const n = encodeURIComponent(this.encoder.encode(e)), i = new Date(Date.now() + r);
    this.document.cookie = `${t}=${n}; path=${this.path}; expires=${i.toUTCString()}`;
  }
  set(t, e) {
    this.setWithExpiration(t, e, this.defaultTimeToLive);
  }
}
class be extends gt {
  constructor(t, e, r, n) {
    super({}), this.name = t, this.path = e, this.encoder = r, this.document = n;
    const i = H(this.document.cookie);
    i.hasOwnProperty(t) && (this.data = this.encoder.decode(decodeURIComponent(i[t])));
  }
  persist() {
    const t = encodeURIComponent(this.encoder.encode(this.data)), e = this.path;
    this.document.cookie = `${this.name}=${t}; path=${e};`;
  }
  set(t, e) {
    super.set(t, e), this.persist();
  }
  remove(t) {
    super.remove(t), this.persist();
  }
  static parseString(t) {
    return H(t);
  }
}
class Ee extends gt {
  constructor() {
    super({}), this.loadList = {};
  }
  isFunction(t) {
    return t && Object.prototype.toString.call(t) === "[object Function]";
  }
  get(t) {
    const e = this.data[t];
    return this.isFunction(e) && !this.loadList.hasOwnProperty(t) && (this.data[t] = e(), this.loadList[t] = !0), this.data[t];
  }
}
const F = class F extends M {
  constructor(t) {
    super(), this.driver = t;
  }
  has(t) {
    return this.driver.has(t);
  }
  set(t, e) {
    return this.driver.set(t, e);
  }
  get(t) {
    return this.driver.get(t);
  }
  keys() {
    return this.driver.keys();
  }
  remove(t) {
    return this.driver.remove(t);
  }
};
F.ObjectDriver = gt, F.StorageDriver = we, F.CookieDriver = be, F.LazyLoadDriver = Ee;
let At = F;
function Dt(s) {
  return !isNaN(parseFloat(s)) && isFinite(s);
}
function ve(s, t) {
  return s < t ? -1 : s > t ? 1 : 0;
}
class Q {
  constructor(t = navigator.userAgent) {
    this.value = t, this.platform = "", this.browser = "", this.version = "";
    const { platform: e, browser: r, version: n } = Q.parseUserAgent(t);
    this.platform = e, this.browser = r, this.version = n;
  }
  static versionComparator(t, e) {
    const r = String(t).split("."), n = String(e).split("."), i = Math.max(r.length, n.length);
    for (let o = 0; o < i; o++) {
      const a = (r.hasOwnProperty(o) ? r[o] : "0").toLowerCase(), h = (n.hasOwnProperty(o) ? n[o] : "0").toLowerCase(), c = Dt(a) && Dt(h) ? Number(a) - Number(h) : ve(a, h);
      if (c !== 0)
        return c / Math.abs(c);
    }
    return 0;
  }
  browserIs(t) {
    return t == this.browser;
  }
  browserIsIn(t) {
    return t.indexOf(this.browser) >= 0;
  }
  browserIsVersionOrGreater(t, e) {
    return t != this.browser ? !1 : Q.versionComparator(this.version, e) >= 0;
  }
  browserIsLessThanVersion(t, e) {
    return t != this.browser ? !1 : Q.versionComparator(this.version, e) < 0;
  }
  static parseUserAgent(t = navigator.userAgent) {
    const e = ["Android", "Xbox"];
    let r, n = "", i = "", o = "";
    if (!t)
      return { platform: n, browser: i, version: o };
    const a = t.match(/\((.*?)\)/im);
    if (a) {
      const w = new RegExp("(Android|CrOS|iPhone|iPad|Linux|Macintosh|Windows( Phone)?|Silk|linux-gnu|BlackBerry|PlayBook|Nintendo (WiiU?|3DS)|Xbox)", "gm"), x = [];
      for (r = w.exec(a[1]); r; )
        x.indexOf(r[1]) == -1 && x.push(r[1]), r = w.exec(a[1]);
      if (x.length >= 1) {
        n = x[0];
        for (const L in x)
          x.hasOwnProperty(L) && e.indexOf(x[L]) >= 0 && (n = x[L]);
      }
    }
    n == "linux-gnu" ? n = "Linux" : n == "CrOS" && (n = "Chrome OS");
    const h = new RegExp("(Camino|Kindle( Fire Build)?|Firefox|Safari|MSIE|Trident/.*rv|AppleWebKit|Chrome|IEMobile|Opera|OPR|Silk|Lynx|Version|Wget|curl|NintendoBrowser|PLAYSTATION (\\d|Vita)+)(?:\\)?;?)(?:(?:[:/ ])([0-9A-Z.]+)|/(?:[A-Z]*))", "ig"), c = [], u = [];
    for (r = h.exec(t); r; )
      c.push(r[1]), u.push(r[4]), r = h.exec(t);
    i = c[0] ?? "", o = u[0] ?? "";
    const l = c.indexOf("Version") >= 0 ? u[c.indexOf("Version")] : "";
    if (c.indexOf("Playstation Vita") >= 0)
      return {
        platform: "PlayStation Vita",
        browser: "Browser",
        version: o
      };
    const d = c.indexOf("Kindle Fire Build");
    if (d >= 0) {
      let w = u[d];
      return (!w || !parseInt(w, 10)) && (w = l), {
        browser: "Kindle",
        platform: "Kindle Fire",
        version: w
      };
    }
    const f = c.indexOf("Silk");
    if (f >= 0) {
      let w = u[f];
      return (!w || !parseInt(w, 10)) && (w = l), {
        browser: "Silk",
        platform: "Kindle Fire",
        version: w
      };
    }
    const y = c.indexOf("NintendoBrowser");
    if (y >= 0 || n == "Nintendo 3DS")
      return {
        browser: "NintendoBrowser",
        version: y === -1 ? o : u[y],
        platform: n
      };
    const m = c.indexOf("Kindle");
    if (m >= 0)
      return {
        browser: c[m],
        version: u[m],
        platform: "Kindle"
      };
    const p = Math.max(c.indexOf("OPR"), c.indexOf("Opera"));
    if (p >= 0)
      return {
        platform: n,
        browser: "Opera",
        version: l || u[p]
        // I know this is backwards. Ask @donatj
      };
    const v = c.indexOf("AppleWebKit");
    if (v === 0 && (n == "Android" || c.indexOf("Chrome") >= 0))
      return {
        platform: n,
        browser: "Chrome",
        version: l
      };
    if (v === 0 && (n == "Blackberry" || n == "PlayBook"))
      return {
        platform: n,
        browser: "BlackBerry Browser",
        version: l
      };
    if (v === 0 && c.indexOf("Safari") >= 0)
      return {
        platform: n,
        browser: "Safari",
        version: l
      };
    if (v === 0)
      return { platform: n, browser: i, version: u[v] };
    if (i == "MSIE" || i.indexOf("Trident") >= 0) {
      const w = c.indexOf("IEMobile");
      return {
        platform: n,
        browser: w >= 0 ? "IEMobile" : "MSIE",
        version: w >= 0 ? u[w] : o
      };
    }
    return c.indexOf("PLAYSTATION 3") >= 0 ? {
      platform: "PlayStation 3",
      browser: "NetFront",
      version: o
    } : { platform: n, browser: i, version: o };
  }
}
const ft = "data-myon-name", xe = "[" + ft + "]", q = "data-myon-namespace", Oe = "[" + q + "]", j = "data-myon-template", Te = "[" + j + "]", Mt = "data-myon-source", ke = "data-myon-", Lt = "data-myon-on-", Se = "data-myon-sort", It = "view-hidden", Ce = "data-myon-model", Pe = "data-myon-hook-add", Ne = "data-myon-hook-remove", Ae = [
  "submit",
  "click",
  "mouseup",
  "mouseover",
  "mouseenter",
  "mouseleave",
  "mousemove",
  "keyup",
  "keydown",
  "change",
  "keypress",
  "input",
  "focus",
  "blur",
  "focusin",
  "focusout",
  "scroll"
], De = new RegExp("^" + ke + "(" + Ae.join("|") + ")"), R = "@@bail", Ft = document.createElement("div");
class Xt {
  constructor(t = {}, e = {}) {
    this.topScope = t, this.topData = e;
  }
  make(t, e, r, n = null, i = null) {
    const o = Object.create(this.topData), a = Object.create(this.topScope);
    if (r !== void 0)
      for (let c = r; c; c = Object.getPrototypeOf(c)) {
        const u = Object.getOwnPropertyNames(c);
        for (const l of u)
          o.hasOwnProperty(l) || Object.defineProperty(o, l, {
            enumerable: !0,
            get: () => r[l],
            set: (d) => r[l] = d
          });
      }
    o.hasOwnProperty("$value") || (o.$value = o), e !== void 0 && Object.keys(e).forEach((c) => {
      a[c] = e[c];
    });
    const h = B.htmlToElement(t, n, i);
    return new B(h, a, o);
  }
}
class Rt {
  constructor(t, e = {}, r = {}) {
    this.scopeData = e, this.pushIndex = 0, this.all = {}, this.sourceHTML = t.outerHTML, this.sortBy = t.getAttribute(Se), this.hookAdd = t.getAttribute(Pe), this.hookRemove = t.getAttribute(Ne), this.parentNode = t.parentNode, this.nextSibling = wt(t), this.viewFactory = new Xt(e, r), this.parentNode.removeChild(t);
  }
  /**
   * Adds a DOM node to the collection in place, with reference to next sibling
   */
  pushNode(t) {
    this.nextSibling && this.nextSibling.parentNode == this.parentNode ? this.parentNode.insertBefore(t, this.nextSibling) : this.parentNode.appendChild(t);
  }
  /**
   * Creates a view element from data, and associates it with a name
   * @param {string} name The name to identify the view
   * @param {Object} viewData The data to add to the view
   * @function Myon.View.CollectionView#add
   * @return {Myon.View}
   */
  add(t, e) {
    const r = this.buildView(t, e);
    return this.sortBy && typeof this.scopeData[this.sortBy] < "u" ? this.sort(this.scopeData[this.sortBy]) : this.pushNode(r.element), r;
  }
  push(t) {
    return this.add(this.pushIndex + 1, t);
  }
  buildView(t, e) {
    e instanceof Object && !(e instanceof Date) ? e = Object.create(e) : e = { $value: e }, e.$key = String(t), typeof t == "number" && t > this.pushIndex && (this.pushIndex = t);
    const r = this.nextSibling && this.nextSibling.parentNode === this.parentNode ? this.nextSibling : null, n = this.parentNode.tagName === "SELECT" ? this.parentNode.selectedIndex : -1, i = this.viewFactory.make(this.sourceHTML, void 0, e, this.parentNode, r);
    return n != -1 && (this.parentNode.selectedIndex = n), this.all[t] = i, this.hookAdd && this.scopeData[this.hookAdd](i), i;
  }
  sort(t) {
    const e = Object.values(this.all), r = document.createDocumentFragment();
    e.sort(t), e.forEach((n) => {
      r.appendChild(n.element);
    }), this.pushNode(r);
  }
  invalidate(t) {
    for (const e in this.all)
      this.all.hasOwnProperty(e) && this.all[e].invalidate(t);
  }
  count() {
    return Object.keys(this.all).length;
  }
  /**
   * Updates a view identified by a name
   * @param  {string} name The name which identifies the view
   * @param  {Object} data The data to update piecemeal
   * @function Myon.View.CollectionView#update
   */
  update(t, e) {
    if (!this.has(t))
      throw new Error(`Cannot update: missing entry "${t}"`);
    const r = this.all[t];
    return r.set(e), r;
  }
  /**
   * Updates all views to match an input. Removes views not in the input
   * @param  {object} map A map from name to data used to update view data
   * @function Myon.View.CollectionView#updateAll
   */
  updateAll(t) {
    const e = {}, r = {};
    for (const a in t) {
      if (!t.hasOwnProperty(a))
        continue;
      let h = a;
      t[a].hasOwnProperty("$key") && (h = t[a].$key), e[a] = h, r[h] = a;
    }
    for (const a in this.all)
      this.all.hasOwnProperty(a) && (t.hasOwnProperty(r[a]) || this.remove(a));
    const n = [];
    for (const a in t) {
      if (!t.hasOwnProperty(a))
        continue;
      const h = e[a];
      this.has(h) ? n.push(this.update(h, t[a]).element) : n.push(this.buildView(h, t[a]).element);
    }
    if (n.length === 0 || this.updateSort())
      return;
    let o = !0;
    for (let a = 1; a < n.length; a++)
      if (n[a - 1].nextElementSibling != n[a]) {
        o = !1;
        break;
      }
    if (!o) {
      const a = document.createDocumentFragment();
      n.forEach((h) => a.appendChild(h)), this.pushNode(a);
    }
  }
  updateSort() {
    return this.sortBy ? typeof this.scopeData[this.sortBy] > "u" ? (console.warn(`Sort method "${this.sortBy}" unavailable`), !1) : (this.sort(this.scopeData[this.sortBy]), !0) : !1;
  }
  /**
   * Inserts or updates views in the collectionview
   * @param  {string} name
   * @param  {Object} data
   * @function Myon.View.CollectionView#replace
   * @return {Myon.View}
   */
  replace(t, e) {
    return this.has(t) ? this.update(t, e) : this.add(t, e);
  }
  /**
   * Removes a view given a name
   * @param  {string} name
   * @function Myon.View.CollectionView#remove
   */
  remove(t) {
    if (!this.all.hasOwnProperty(t))
      return;
    this.hookRemove && this.scopeData[this.hookRemove](this.all[t]);
    const e = this.all[t].element;
    e.parentNode && e.parentNode.removeChild(e), delete this.all[t];
  }
  /**
   * Empties the CollectionView
   * @function Myon.View.CollectionView#empty
   */
  empty() {
    for (const t in this.all)
      this.all.hasOwnProperty(t) && this.remove(t);
    this.pushIndex = 0;
  }
  /**
   * Checks if the collection has an element identified by name
   * @param  {string}  name
   * @return {Boolean}
   * @function Myon.View.CollectionView#has
   */
  has(t) {
    return this.all.hasOwnProperty(t);
  }
  /**
   * Gets the view associated with the name in the collection
   * @param  {string} name
   * @return {Myon.View}
   * @function Myon.View.CollectionView#get
   */
  get(t) {
    if (!this.has(t))
      throw new Error("Unknown key: " + t);
    return this.all[t];
  }
  /**
   * Executes a callback on each view in the collection
   * @param  {Function} callback
   * @function Myon.View.CollectionView#forEach
   */
  forEach(t) {
    for (const e in this.all)
      this.all.hasOwnProperty(e) && t.call(null, this.all[e], e);
  }
  /**
   * Adds filters to the scope by key
   * @param {Object} map
   * @return {Myon.View.CollectionView}
   * @function Myon.View.CollectionView#scope
   */
  scope(t) {
    for (const e in t)
      t.hasOwnProperty(e) && (this.scopeData[e] = t[e]);
    return this;
  }
}
class Me {
  constructor(t, e) {
    Object.defineProperties(this, {
      $value: { value: e.get("$value") },
      $key: { value: e.get("$key") }
    }), t.forEach((r) => {
      r == "$key" || r == "$value" || Object.defineProperty(this, r, {
        set: (n) => {
          e.set({ [r]: n });
        },
        get: () => e.get(r)
      });
    });
  }
}
const N = class N {
  constructor(t, e = {}, r = {}) {
    this.binds = {}, this.sourceMap = {}, this.scopeData = Object.create(e), t instanceof Element || (t = N.htmlToElement(String(t))), this.element = t, this.data = r, this.initializeControl(), this.invalidate(), Array.from(this.element.querySelectorAll("." + It)).concat(this.element).forEach((n) => {
      n.classList.remove(It);
    });
  }
  keys() {
    const t = [];
    for (const e in this.data)
      t.push(e);
    return t;
  }
  get dataset() {
    return this.dataAccess || (this.dataAccess = new Me(this.keys(), this)), this.dataAccess;
  }
  getData(t) {
    let e = this.data;
    for (let r = 0; r < t.length; r++) {
      if (!e.hasOwnProperty(t[r]))
        return {};
      e = e[t[r]];
    }
    return e;
  }
  invalidate(t) {
    if (t === void 0) {
      for (t of this.keys())
        this.invalidate(t);
      this.invalidate("$key"), this.invalidate("$value");
      return;
    }
    for (const e in this.sourceMap) {
      if (!this.sourceMap.hasOwnProperty(e))
        continue;
      const r = this[e];
      if (!(r instanceof Rt))
        continue;
      const n = this.sourceMap[e].split(".");
      if (n[0] != t) {
        r.invalidate(t);
        continue;
      }
      r.updateAll(this.getData(n));
    }
    if (this.binds.hasOwnProperty(t))
      for (let e = 0; e < this.binds[t].length; e++)
        this.binds[t][e].update(this.data, this.scopeData);
  }
  /**
   * Attaches handlers to the view
   * @param {Object} map Handlers keyed by handler name
   * @return {Myon.View}
   * @function Myon.View#addHandlers
   */
  scope(t) {
    for (const e in t)
      t.hasOwnProperty(e) && (this.scopeData[e] = t[e]);
    return this;
  }
  aliasCollectionView(t, e, r) {
    return this[t] = r, this.sourceMap[t] = e, this;
  }
  /**
   * Sets a map of values to the internal data store
   * @param {Object} map Values keyed by value name
   * @return {Myon.View}
   * @function Myon.View#set
   */
  set(t) {
    for (const e in t) {
      const r = typeof t[e];
      this.data.hasOwnProperty(e) && // property is already set
      this.data[e] == t[e] && // data matches
      (r == "number" || r == "string" || r == "boolean") || (this.data[e] = t[e], this.invalidate(e));
    }
    return this.invalidate("$value"), this;
  }
  get(t) {
    return this.data[t];
  }
  initializeControl() {
    Re(this, this.scopeData, this.data);
    const t = C.scanTextNodeTemplates(this.element).concat(C.scanAttributes(this, this.data, this.scopeData, this.element));
    Qt(this.element, this);
    for (const e of t)
      for (const r of e.dataSources)
        this.binds[r] || (this.binds[r] = []), this.binds[r].push(e);
  }
  /**
   * Converts an HTML string into an Element
   * @param  {string}      html HTML input string
   * @return {Element}
   * @function Myon.View.htmlToElement
   */
  static htmlToElement(t, e = null, r = null) {
    t = t.trim();
    const n = t.toLowerCase().match(/^<([a-z]+)/), i = N.getParentTagName(n ? n[1] : !1), o = document.createElement(i);
    o.innerHTML = t;
    const a = o.childNodes.length != 1 ? o : o.childNodes[0];
    return e && r ? e.insertBefore(a, r) : e ? e.appendChild(a) : a != o && o.removeChild(a), a;
  }
};
N.CollectionView = Rt, N.Factory = Xt, N.getParentTagName = function(t) {
  if (!t)
    return "span";
  const e = {
    tr: "tbody",
    // table causes issues here. In chrome, table added with implicit tbody
    td: "tr",
    tbody: "table",
    thead: "table",
    tfoot: "table",
    th: "tr",
    option: "select"
  };
  return t = t.toLowerCase().trim(), e.hasOwnProperty(t) ? e[t] : "div";
}, N.escapeHtml = function(t) {
  return Ft.textContent = t, Ft.innerHTML;
};
let B = N;
function Bt(s, t, e, r, n, i) {
  function o(h, c, u) {
    const l = c.match(/^([^(]+)\((.*?)\)$/), d = [];
    l && (c = l[1], d.push(...l[2].split(",").map((f) => f.trim()))), n.addEventListener(h, function(f) {
      if (!(c in e))
        throw new Error("Unregistered handler: `" + c + "`");
      if (u && f.keyCode && [13, 32].indexOf(f.keyCode) == -1)
        return;
      const y = [...d.map((p) => s.dataset[p]), f, t, s];
      e[c].apply(n, y) === !1 && (f.preventDefault(), f.stopPropagation());
    });
  }
  function a(h) {
    h.addEventListener("keydown", (c) => {
      (c.keyCode == 32 || c.keyCode == 13) && c.stopPropagation();
    }), h.addEventListener("keyup", (c) => {
      (c.keyCode == 32 || c.keyCode == 13) && c.stopPropagation();
    });
  }
  r === "click" && (n instanceof HTMLElement && a(n), n.tagName != "BUTTON" && o("keypress", i, !0)), o(r, i, !1);
}
function Le(s, t, e, r) {
  r instanceof HTMLInputElement && r.type == "radio" ? r.addEventListener("change", () => {
    r.checked && (s.dataset[t] = e(r.value));
  }) : r instanceof HTMLInputElement && r.type == "checkbox" ? r.addEventListener("change", () => {
    s.dataset[t] = r.checked;
  }) : (r instanceof HTMLInputElement || r instanceof HTMLSelectElement || r instanceof HTMLTextAreaElement) && r.addEventListener("input", () => {
    s.dataset[t] = e(r.value);
  });
}
function Qt(s, t) {
  Ie(s, t);
  const e = s.querySelectorAll(Oe);
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (yt(q, n.parentNode, s) !== void 0)
      continue;
    const i = n.getAttribute(q);
    if (!i)
      continue;
    const o = {};
    n.removeAttribute(q), Yt(i, o, t), Qt(n, o);
  }
}
const ut = {};
function Yt(s, t, e) {
  if (!ut.hasOwnProperty(s)) {
    const i = s.match(/^(.*?)(\[\s*(.*?)\s*\])?$/);
    if (!i)
      throw new Error(`Could not parse name ${s}`);
    ut[s] = [i[1], i[3]];
  }
  const [r, n] = ut[s];
  if (n === void 0) {
    e[r] = t;
    return;
  }
  if (e.hasOwnProperty(r) || (e[r] = n === "" ? [] : {}), n === "") {
    if (!Array.isArray(e[r]))
      throw new Error(`target[${r}] exists and is not an array`);
    e[r].push(t);
    return;
  }
  e[r][n] = t;
}
function Ie(s, t) {
  const e = s.querySelectorAll(xe);
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (yt(q, n.parentNode, s) !== void 0)
      continue;
    const i = n.getAttribute(ft);
    i && (n.removeAttribute(ft), Yt(i, n, t));
  }
}
function yt(s, t, e = document.body) {
  for (; t && t != e; ) {
    if (t.hasAttribute(s))
      return t;
    t = t.parentNode;
  }
}
function Fe(s) {
  if (s.childNodes.length > 0) {
    const e = s.childNodes[s.childNodes.length - 1];
    e instanceof Text && String(e.textContent).trim() == "" && s.removeChild(e);
  }
  if (s.childNodes.length === 0)
    return;
  const t = s.childNodes[0];
  t instanceof Text && String(t.textContent).trim() == "" && s.removeChild(t);
}
function Re(s, t, e) {
  const r = s.element.querySelectorAll(Te);
  for (let n = 0; n < r.length; n++) {
    const i = r[n], o = i.parentNode;
    if (!(o instanceof Element) || !i.hasAttribute(j) || yt(j, o, s.element))
      continue;
    const a = i.getAttribute(j);
    let h = i.getAttribute(Mt);
    h ? i.removeAttribute(Mt) : h = a, i.removeAttribute(j), Fe(o);
    const c = new B.CollectionView(
      i,
      Object.create(t),
      Object.create(e)
    );
    s.aliasCollectionView(a, h, c);
  }
}
const vt = class vt {
  constructor(t, e, r) {
    this.dataSources = t, this.operation = e, this.dataTarget = r;
  }
  update(t, e) {
    const r = this.operation(t, e);
    r !== R && this.dataTarget(r);
  }
};
vt.BAIL = R;
let E = vt;
const S = {
  makeTextNodeDataTarget(s) {
    return function(e) {
      e != s.textContent && (s.textContent = e);
    };
  },
  makeAttributeDataTarget(s) {
    return function(e) {
      e != s.value && (s.value = e);
    };
  },
  makeAttributeProxyDataTarget(s, t) {
    return function(r) {
      r != s.getAttribute(t) && s.setAttribute(t, r);
    };
  },
  makeElementDataTarget(s) {
    const t = s.nextSibling, e = s.parentNode;
    let r = s;
    if (!e)
      throw new Error("No parent node");
    return function(i) {
      i instanceof Node || (i = B.htmlToElement(i)), e.removeChild(r), t && t.parentNode === e ? e.insertBefore(i, t) : e.appendChild(i), r = i;
    };
  },
  makeRadioCheckedDataTarget(s) {
    return function(e) {
      (e == null ? "" : String(e)) === s.value && (s.checked = !0);
    };
  },
  makeCheckboxCheckedDataTarget(s) {
    return function(e) {
      s.checked = e;
    };
  },
  /** @TODO-- DATE! */
  makeInputValueDataTarget(s) {
    return function(e) {
      s.value = e == null ? "" : String(e);
    };
  },
  makePropertyDataTarget(s, t) {
    return function(r) {
      r != s[t] && (s[t] = r);
    };
  },
  makeConditionalRenderDataTarget(s) {
    const t = s.parentNode;
    if (!t)
      throw new Error("No parent node");
    const e = wt(s);
    return function(n) {
      n != (s.parentNode == t) && (n ? t.insertBefore(s, e) : t.removeChild(s));
    };
  }
};
function Ut(s, t) {
  let e = s;
  for (let r = 0; r < t.length; r++) {
    if (typeof e[t[r]] > "u")
      return R;
    e = e[t[r]];
  }
  return e;
}
const g = {
  makePipelineOperation(s) {
    return function(e, r) {
      let n = e;
      for (let i = 0; i < s.length; i++)
        if (n = s[i](n, r), n === R)
          return "";
      return n;
    };
  },
  makeConcatOperation(s) {
    return function(e, r) {
      let n = "";
      for (let i = 0; i < s.length; i++)
        n += s[i](e, r);
      return n;
    };
  },
  makeStringOperation(s) {
    return function() {
      return s;
    };
  },
  makeEqualityCheckOperation(s, t) {
    return function(r, n) {
      return s(r, n) == t(r, n);
    };
  },
  makeStrictEqualityCheckOperation(s, t) {
    return function(r, n) {
      return s(r, n) === t(r, n);
    };
  },
  makeInequalityCheckOperation(s, t) {
    return function(r, n) {
      return s(r, n) != t(r, n);
    };
  },
  makeStrictInequalityCheckOperation(s, t) {
    return function(r, n) {
      return s(r, n) !== t(r, n);
    };
  },
  makeLessThanOperation(s, t) {
    return function(r, n) {
      return s(r, n) < t(r, n);
    };
  },
  makeLessThanOrEqualToOperation(s, t) {
    return function(r, n) {
      return s(r, n) <= t(r, n);
    };
  },
  makeGreaterThanOperation(s, t) {
    return function(r, n) {
      return s(r, n) > t(r, n);
    };
  },
  makeGreaterThanOrEqualToOperation(s, t) {
    return function(r, n) {
      return s(r, n) >= t(r, n);
    };
  },
  makeAndOperation(s, t) {
    return function(r, n) {
      return s(r, n) && t(r, n);
    };
  },
  makeOrOperation(s, t) {
    return function(r, n) {
      return s(r, n) || t(r, n);
    };
  },
  makeDataAccessOperation(s) {
    return function(e) {
      return Ut(e, s);
    };
  },
  makeScopeAccessOperation(s) {
    return function(e, r) {
      const n = Ut(r, s);
      return n === R ? n : n(e);
    };
  },
  makeFalseyBailOperation() {
    return function(t) {
      return t || R;
    };
  },
  makeNotOperation() {
    return function(t) {
      return !t;
    };
  }
};
function jt(s) {
  return Object.assign(s, { acceptNode: s });
}
function wt(s) {
  const t = document.createTextNode("");
  if (!s.parentNode)
    throw console.error("Could not insert a placeholder node: No parent node", s), new Error("No parent node");
  return s.nextSibling ? s.parentNode.insertBefore(t, s) : s.parentNode.appendChild(t), t;
}
const C = {
  /**
   * Walks the DOM tree from the root element, finding all attributes that are bound to the model
   */
  scanAttributes(s, t, e, r) {
    const n = document.createTreeWalker(
      r,
      NodeFilter.SHOW_ELEMENT,
      jt((a) => !(a instanceof Element) || !a.hasAttributes() ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT)
    ), i = C.getElementDataBindings(s, t, e, r);
    let o = n.nextNode();
    for (; o; )
      i.push(...C.getElementDataBindings(s, t, e, o)), o = n.nextNode();
    return i;
  },
  /**
   * Gets all bound attributes over a specific element
   */
  getElementDataBindings(s, t, e, r) {
    const n = [];
    return Array.from(r.attributes).forEach((i) => {
      const o = C.getDataBinding(s, t, e, i, r);
      o && n.push(o);
    }), n;
  },
  getModelDataBinding(s, t, e, r, n) {
    const [i, o] = r.value.split(":").map((c) => c.trim());
    n.removeAttribute(r.name);
    let a = String;
    if (o) {
      const c = o.charAt(0) === "?", u = c ? o.substring(1) : o;
      if (u === "number")
        a = Number;
      else if (u === "boolean")
        a = Boolean;
      else if (u !== "string")
        throw new Error("Could not determine type from property");
      if (c) {
        const l = a;
        a = (d) => d ? l(d) : null;
      }
    }
    Le(s, i, a, n);
    const h = g.makeDataAccessOperation([i]);
    if (n instanceof HTMLInputElement && n.type === "radio")
      return new E(
        [i],
        h,
        S.makeRadioCheckedDataTarget(n)
      );
    if (n instanceof HTMLInputElement && n.type === "checkbox")
      return new E(
        [i],
        h,
        S.makeCheckboxCheckedDataTarget(n)
      );
    if (n instanceof HTMLInputElement || n instanceof HTMLTextAreaElement || n instanceof HTMLSelectElement)
      return new E(
        [i],
        h,
        S.makeInputValueDataTarget(n)
      );
    throw new Error("Model bound elements must be either input, textarea, or select");
  },
  getTemplateDataBinding(s, t, e, r, n) {
    const i = r.name.match(/^data-myon-attr-(.*?)$/), o = Vt(r.value);
    if (i)
      return n.removeAttribute(r.name), new E(
        o.dataSources,
        o.operation,
        S.makeAttributeProxyDataTarget(n, i[1])
      );
    const a = r.name.match(/^data-myon-prop-(.*?)$/);
    return a ? (n.removeAttribute(r.name), new E(
      o.dataSources,
      o.operation,
      S.makePropertyDataTarget(n, a[1])
    )) : r.name == "data-myon-if" ? (n.removeAttribute(r.name), new E(
      o.dataSources,
      o.operation,
      S.makeConditionalRenderDataTarget(n)
    )) : new E(
      o.dataSources,
      o.operation,
      S.makeAttributeDataTarget(r)
    );
  },
  getDataBinding(s, t, e, r, n) {
    if (r.name == Ce)
      return C.getModelDataBinding(s, t, e, r, n);
    if (/{{(.*)}}/.test(r.value))
      return C.getTemplateDataBinding(s, t, e, r, n);
    if (r.name.startsWith(Lt)) {
      n.removeAttribute(r.name), Bt(s, t, e, r.name.substring(Lt.length), n, r.value);
      return;
    }
    const i = r.name.match(De);
    i && (n.removeAttribute(r.name), Bt(s, t, e, i[1], n, r.value));
  },
  parseText(s) {
    if (Y.hasOwnProperty(s))
      return Y[s];
    const t = s.length, e = [];
    let r = "", n = !1;
    const i = () => {
      r.trim() && e.push([n, r]), r = "";
    };
    for (let o = 0; o < t; o++)
      !n && o < t - 1 && s[o] === "{" && s[o + 1] === "{" && (i(), n = !0), r += s[o], n && o < t - 1 && s[o] == "}" && s[o + 1] == "}" && (r += "}", o++, i(), n = !1);
    return i(), Y[s] = e, e;
  },
  scanTextNodeTemplates(s) {
    const t = document.createTreeWalker(
      s,
      NodeFilter.SHOW_TEXT,
      jt((i) => {
        if (!(i instanceof Text) || i.parentNode && i.parentNode.tagName == "SCRIPT")
          return NodeFilter.FILTER_SKIP;
        const o = i.wholeText.trim();
        if (!o)
          return NodeFilter.FILTER_SKIP;
        const a = o.indexOf("{{");
        return a == -1 || o.indexOf("}}", a) == -1 ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
      })
    ), e = [];
    let r = t.nextNode();
    for (; r; )
      e.push(r), r = t.nextNode();
    const n = [];
    for (let i = 0; i < e.length; i++) {
      const o = e[i], a = C.parseText(o.wholeText), h = o.parentNode, c = document.createDocumentFragment(), u = wt(o), l = [];
      for (let d = 0; d < a.length; d++) {
        const [f, y] = a[d], m = document.createTextNode(f ? "" : y);
        c.appendChild(m), f && l.push(() => {
          const p = Vt(y);
          y.indexOf("@noescape") >= 0 && y.match(/(@noescape)\s*}}/m) ? n.push(new E(
            p.dataSources,
            p.operation,
            S.makeElementDataTarget(m)
          )) : n.push(new E(
            p.dataSources,
            p.operation,
            S.makeTextNodeDataTarget(m)
          ));
        });
      }
      h.insertBefore(c, u), h.removeChild(o), l.forEach((d) => d());
    }
    return n;
  }
}, V = {}, Y = {};
function Be(s) {
  const t = [], e = [], r = s.replace(/\|/g, "|,").replace(/\|,\|,/g, "||").split("|,");
  for (let n = 0; n < r.length; n++) {
    const i = r[n].match(/^\s*(!?)('?)(.*?)(\s*(===?|&&|\|\||!==?|<=?|>=?)\s*(.*?))?('?)\s*(\??)\s*(@noescape)?\s*$/);
    if (!i)
      throw new Error("Could not match pipeline string");
    const [, o, a, h, , c, u, l, d] = i;
    if (a == "'" && l == "'")
      t.push(g.makeStringOperation(h));
    else if (n === 0 && c) {
      const f = h.trim().split("."), y = u.trim().split("."), m = g.makeDataAccessOperation(f), p = g.makeDataAccessOperation(y);
      e.push(f[0], y[0]), c == "==" ? t.push(g.makeEqualityCheckOperation(m, p)) : c == "===" ? t.push(g.makeStrictEqualityCheckOperation(m, p)) : c == "!=" ? t.push(g.makeInequalityCheckOperation(m, p)) : c == "!==" ? t.push(g.makeStrictInequalityCheckOperation(m, p)) : c == "<" ? t.push(g.makeLessThanOperation(m, p)) : c == "<=" ? t.push(g.makeLessThanOrEqualToOperation(m, p)) : c == ">" ? t.push(g.makeGreaterThanOperation(m, p)) : c == ">=" ? t.push(g.makeGreaterThanOrEqualToOperation(m, p)) : c == "&&" ? t.push(g.makeAndOperation(m, p)) : c == "||" && t.push(g.makeOrOperation(m, p));
    } else if (n === 0) {
      const f = h.split(".");
      e.push(f[0]), t.push(g.makeDataAccessOperation(f));
    } else {
      const f = h.split(".");
      t.push(g.makeScopeAccessOperation(f));
    }
    o == "!" && t.push(g.makeNotOperation()), d == "?" && t.push(g.makeFalseyBailOperation());
  }
  return {
    operation: t.length === 1 ? t[0] : g.makePipelineOperation(t),
    dataSources: e
  };
}
function Vt(s) {
  const t = [], e = [], r = /^([^]*?)({{(.+?)}})([^]*)$/;
  let n = s.match(r), i;
  for (; n; ) {
    const [, o, , a, h] = n;
    n[1].length > 0 && t.push(g.makeStringOperation(o)), i = a.trim(), V.hasOwnProperty(i) || (V[i] = Be(i)), e.push(...V[i].dataSources), t.push(V[i].operation), s = h, n = s.match(r);
  }
  return s && t.push(g.makeStringOperation(s)), {
    operation: t.length === 1 ? t[0] : g.makeConcatOperation(t),
    dataSources: e
  };
}
window.__silver_view_textNodeCache = Y;
window.__silver_view_pipelineCache = V;
function Ue(s, t) {
  const e = (...r) => t.printf(s, r);
  return e.toString = () => s, e;
}
function $t(s, t) {
  const e = {};
  for (const r in t)
    t.hasOwnProperty(r) && (e[r] = Ue(t[r], s));
  return e;
}
class Jt {
  constructor(t) {
    this.languageFetcher = t, this.cache = {}, this.extensions = {}, this.format = new Z();
  }
  fetch(t) {
    return this.cache[t] || (this.cache[t] = this.doFetch(t)), this.cache[t];
  }
  async doFetch(t) {
    try {
      const e = await this.languageFetcher(t), r = $t(this.format, e);
      return this.applyExtensions(t, r), r;
    } catch (e) {
      throw delete this.cache[t], e;
    }
  }
  applyExtensions(t, e) {
    if (this.extensions.hasOwnProperty(t))
      for (let r = 0; r < this.extensions[t].length; r++) {
        const n = this.extensions[t][r];
        for (const i in n)
          n.hasOwnProperty(i) && (e[i] = n[i]);
      }
  }
  load(t) {
    return this.fetch(t);
  }
  extend(t, e) {
    this.extensions.hasOwnProperty(t) || (this.extensions[t] = []), this.extensions[t].push(e);
  }
  inject(t, e) {
    const r = $t(this.format, e);
    return this.applyExtensions(t, r), this.cache[t] = Promise.resolve(r), r;
  }
  static makeStandard(t, e) {
    const r = async (n) => {
      const i = await e(n), o = await t.get(i);
      if (!o.hasOwnProperty("status") || o.status != "success")
        throw new Error("Could not load language data");
      return o.result[n];
    };
    return new Jt(r);
  }
}
const je = /(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
function Ve(s) {
  const t = String(s).toLowerCase().match(je), e = [];
  if (!t)
    return e;
  for (let r = 0; r < t.length; r++) {
    let n = t[r];
    r < t.length - 1 && n == "-" && !isNaN(Number(t[r + 1])) && (n = "-" + t[r + 1], r++), isNaN(Number(n)) ? e.push(n) : e.push(Number(n));
  }
  return e;
}
class mr {
  constructor() {
    this.preparedStrings = {};
  }
  prepare(t) {
    return this.preparedStrings.hasOwnProperty(t) || (this.preparedStrings[t] = Ve(t)), this.preparedStrings[t];
  }
  compare(t, e) {
    if (t === e)
      return 0;
    const r = this.prepare(t), n = this.prepare(e), i = Math.max(r.length, n.length);
    let o;
    for (o = 0; o < i; o++) {
      if (o >= n.length)
        return 1;
      if (o >= r.length)
        return -1;
      const a = r[o], h = n[o];
      if (a === h)
        continue;
      const c = Number(a) - Number(h);
      return isNaN(c) ? String(a) > String(h) ? 1 : -1 : c;
    }
    return n[o] ? -1 : 0;
  }
}
function $e(s, t) {
  const e = Math.pow(10, t);
  return Math.round(s * e) / e;
}
class et {
  constructor(t = "transform", e = "transitionDuration", r = "transitionTimingFunction", n = "transformOrigin") {
    this.transformProperty = t, this.durationProperty = e, this.easingProperty = r, this.originProperty = n;
  }
  buildTranslateValue(t, e = 0) {
    return `translate3d(${t}px, ${e}px, 0px)`;
  }
  buildOriginValue(t, e) {
    return t = String(t), e = String(e), e.charAt(e.length - 1) != "%" && (e = parseInt(e, 10) + "px"), t.charAt(t.length - 1) != "%" && (t = parseInt(t, 10) + "px"), `${t} ${e}`;
  }
  buildScaleValue(t) {
    return t = $e(t, 7), `scale3d(${t}, ${t}, 1)`;
  }
  buildTranslateScaleValue(t, e, r) {
    return `${this.buildTranslateValue(t, e)} ${this.buildScaleValue(r)}`;
  }
}
class He extends et {
  constructor() {
    super("msTransform", "msTransitionDuration", "msTransitionTimingFunction", "msTransformOrigin");
  }
  buildTranslateValue(t, e) {
    return `translate(${t}px, ${e}px)`;
  }
}
class qe extends et {
}
class Ke extends et {
  constructor() {
    super("WebkitTransform", "WebkitTransitionDuration", "webkitTransitionTimingFunction", "WebkitTransformOrigin");
  }
}
class pt {
  constructor(t) {
    this.driver = t;
  }
  static autoDetectDriver(t) {
    return t.browserIsIn(["Android Browser", "Safari", "Chrome", "Opera", "Opera Mobile", "Silk"]) ? new Ke() : t.browserIsVersionOrGreater("MSIE", "9") ? new He() : new et();
  }
  static fromUserAgent(t) {
    return new pt(pt.autoDetectDriver(t));
  }
  get isEnabled() {
    return !(this.driver instanceof qe);
  }
  get transformProperty() {
    return this.driver.transformProperty;
  }
  get durationProperty() {
    return this.driver.durationProperty;
  }
  get easingProperty() {
    return this.driver.easingProperty;
  }
  get originProperty() {
    return this.driver.originProperty;
  }
  translate(t, e) {
    return this.driver.buildTranslateValue(t, e);
  }
  origin(t, e) {
    return this.driver.buildOriginValue(t, e);
  }
  scale(t) {
    return this.driver.buildScaleValue(t);
  }
  translateScale(t, e, r) {
    return this.driver.buildTranslateScaleValue(t, e, r);
  }
  setTransform(t, e) {
    t.style[this.transformProperty] = e.join(" ");
  }
  setOrigin(t, e, r) {
    t.style[this.originProperty] = this.origin(e, r);
  }
  setEasing(t, e) {
    t.style[this.easingProperty] = e;
  }
  setTranslate(t, e, r) {
    this.setTransform(t, [this.translate(e, r)]);
  }
  setTranslateScale(t, e, r, n) {
    this.setTransform(t, [this.translateScale(e, r, n)]);
  }
  setScale(t, e) {
    this.setTransform(t, [this.scale(e)]);
  }
  setDuration(t, e) {
    !isNaN(e) && isFinite(e) && (e = `${e}ms`), t.style[this.durationProperty] = e;
  }
}
export {
  tr as AnimateTo,
  J as Animation,
  dt as AnimationEasing,
  qt as BaseModuleLoader,
  M as BaseRegistry,
  ie as Bootstrapper,
  Qe as CachingBandwidthTest,
  _t as Client,
  Rt as CollectionView,
  b as Color,
  er as Cookie,
  be as CookieDriver,
  pr as CookieValueRegistry,
  he as CustomError,
  hr as DataSet,
  Ht as DependencyInjector,
  Ge as DownlinkBandwidthTest,
  Ye as ESModuleLoader,
  T as EventListener,
  fr as ExpiringRegistryProxy,
  Nt as FocusControl,
  $ as FormDataEncoder,
  Z as Format,
  O as HSVColor,
  kt as HttpClient,
  qe as InvalidDriver,
  Ze as JSONEncoder,
  W as JWT,
  U as KeyCodeStrings,
  ot as KeyCodes,
  de as KeyCommand,
  Pt as KeyCommandRegistry,
  Jt as LanguageLoader,
  Ee as LazyLoadDriver,
  He as MSDriver,
  mr as NaturalComparator,
  gt as ObjectDriver,
  A as PathInfo,
  We as PerformanceApiTest,
  lr as PrefixedRegistryProxy,
  ur as Random,
  At as Registry,
  Xe as RequestBandwidthTest,
  Je as RequireJSBootstrapper,
  mt as RequireJSModuleLoader,
  _e as ResultObservingBandwidthTesterProxy,
  Ct as RouteGenerator,
  tt as RouteInfo,
  dr as SizeLimitedRegistryProxy,
  ze as StaticBandwidthTest,
  we as StorageDriver,
  pt as Transform,
  et as TransformDriver,
  Q as UserAgent,
  B as View,
  Ke as WebkitDriver,
  nr as WindowFocus,
  Tt as XMLEncoder,
  or as getElementDocumentPosition,
  Wt as isHTMLElement,
  ge as isHTMLElementOfType,
  rr as keyCodeToString,
  cr as makeHTMLElement,
  sr as mustBeHTMLElement,
  ir as mustBeHTMLElementOfType,
  ar as onDocumentReady,
  ye as waitForDocumentReady
};
//# sourceMappingURL=silver.js.map
